











































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import HintsContainer from "@/components/HintsContainer.vue";
import KviCartSelect from "@/components/KviCartSelect.vue";
import MarketSelect from "@/components/MarketSelect.vue";
import MultiSelect from "@/components/MultiSelect.vue";
import ResultView from "@/components/ResultView.vue";
import SideToolbar from "@/components/SideToolbar.vue";

import {
    CalcIndividualConfig,
    ConfigMap,
    SelectOption,
    IndividualConfig,
    SelectBox,
    SelectKviCart,
    TaskInfoCalc,
} from "@/interfaces/global-data";
import {
    CompetitorsPriceFilter,
    GetTaskInfo,
    InternalCodeAndProductRange,
    KviCartFilters,
    KviCartPackageConfig,
    KviCartsSkuFilter,
    KviShoppingCartFilters,
    ProductSegmentIdAndName,
    RegularCompetitorsPricesView,
    Segment,
    Sku,
    SortingField,
    TaskAndFile,
    TaskData,
    TaskInfoFilterType,
    kviCartChangePricesSb,
    SkuFilter,
    IProductsToLinkToCompetitor,
    ILinkedProductsTableOptions,
    ILinkedProductsTableFilterValues,
    ISelectCompetitorOptionsItem,
    ProductInfo,
    ProductTag,
    ICompetitorProduct,
    IdAndName,
    ICompetitorSelected,
    ICompetitorSelectionTask,
} from "@/interfaces/server-data";
import Http from "@/mixins/http";
import { FormatNumber } from "@/numberFormatter";
import { Formatter } from '@/helpers/formatters';
import { BTabs } from "bootstrap-vue";
import moment from "moment";
import Vue from "vue";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import vSelect from "@/components/UI/vSelect.vue";
import CSelect from "@/components/UI/CoefficientSelect.vue";

import { CompetitorsPriceRow } from "@/interfaces/competitors-price-row";
import { compareNumber } from "@/utils/arrayUtils";
import CollapseCard from "../UI/CollapseCard.vue";

import LocalData from "@/mixins/local-data";
import Toast from "@/mixins/toast";
import Card from "../UI/Card.vue";
import StringViewAndEdit from "../UI/Table/StringViewAndEdit.vue";
import {Modal} from "ant-design-vue";

interface FilterItem {
  label: string,
  value: number;
}

interface TheMarket {
  id: number;
  tradingName: string;
  isDefault: boolean;
  editable: boolean;
}

interface IModalLevelFilterCommon {
  groups: FilterItem[];
  categories: FilterItem[];
  subcategories: FilterItem[];
}

interface IModalLevelFiltersSelected {
    groups: number[],
    categories: number[],
    subcategories: number[],
}

interface IInfoTypesSingle {
    groups: string,
    categories: string,
    subcategories: string,
}

interface IExportTemplateFilterOptions {
  groups: FilterItem[];
  categories: FilterItem[];
  subcategories: FilterItem[];
  formats: FilterItem[];
  regions: FilterItem[];
  clusters: FilterItem[];
}

interface IExportTemplateFiltersSelected {
  groups: number[];
  categories: number[];
  subcategories: number[];
  formats: number[];
  regions: number[];
  clusters: number[];
}

interface ILocalstorageCompetitorData {
    code: string;
    formatId: string;
    regionId: string;
    clusterId?: string;
}

@Component({
  components: {
    KviCartSelect,
    ResultView,
    SideToolbar,
    MultiSelect,
    MarketSelect,
    vSelect,
    LocalData,
    HintsContainer,
    CollapseCard,
    Card,
    CSelect,
    StringViewAndEdit,
  },
  filters: {
    formatDate: (v: any) => {
      if (v) {
        return moment(new Date(+v)).format("DD.MM.YYYY");
      }
    },
    formatCompetitorsDate: (v: any) => {
      if (v) {
        return moment(new Date(+v)).format("YYYY-MM-DD");
      }
    },
  },
  methods: {
    changeRowColorInDetailReport(item) {
      if (item !== null) {
        if (item.kvi === "ДА") {
          return "table-primary";
        }
        if (item.resultType === "COMPETITOR") {
          return "table-danger";
        }
      }
    },
    formatNumber(number) {
      if (String(number)[0] === "-") {
        return String(number).substring(0, 4);
      } else {
        return String(number).substring(0, 3);
      }
    },
    replaceCommaFormatter(value) {
      return value.replace(",", ".");
    },
    replaceDecimalFormatter(value) {
      if (value == null) {
        return null;
      } else {
        return parseFloat(
          value.replace(/(\d)(?=(\d{3})+([^\d]|$))/g, "$1").replace(",", ".")
        );
      }
    },
  },
})
export default class ParsingProducts extends Mixins(LocalData, Toast, Http) {
  @Prop({ required: true }) theFilters!: any;
  @Prop({
    required: true,
    default: { id: 0, tradingName: "", isDefault: false, editable: true },
  })
  theMarket!: TheMarket;

  editingUrls: { [x in number]: string | null } = {};

  currentTradingId = this.theMarket ? this.theMarket.id : -1;

  linkedProductsTableOptions: ILinkedProductsTableOptions = {
      competitorCode: [],
      group: [],
      category: [],
      subcategory: [],
      internalCode: [],
      skuName: [],
      storeFormat: [],
      storeRegion: [],
      storeCluster: [],
      keyCharacteristicOne: [],
      keyCharacteristicTwo: [],
      ctm: [],
      kvi: [],
  };

  linkedProductsTableFilterValues: ILinkedProductsTableFilterValues = {
      internalCodes: [],
      skuNames: [],
      categoryIds: [],
      subcategoryIds: [],
      groupIds: [],
      kviValue: -1,
      ctmValue: 'all',
  };

  private selectedCompetitorValue: string | null = null;
  private selectedSite: string | null = null;

  private isLinkProductsModalVisible = false;
  private isExportTemplateModalVisible = false;
  private isExportTemplateLoading = false;
  private exportTemplateOnlyKvi = true;

  exportTemplateFilterOptions: IExportTemplateFilterOptions = {
      groups: [{ value: -1, label: this.$t('shared.selectBox.all') as string }],
      categories: [{ value: -1, label: this.$t('shared.selectBox.all') as string }],
      subcategories: [{ value: -1, label: this.$t('shared.selectBox.all') as string }],
      formats: [{ value: -1, label: this.$t('shared.selectBox.all') as string }],
      regions: [{ value: -1, label: this.$t('shared.selectBox.all') as string }],
      clusters: [{ value: -1, label: this.$t('shared.selectBox.all') as string }],
  };

  exportTemplateFiltersSelected: IExportTemplateFiltersSelected = {
      groups: [-1],
      categories: [-1],
      subcategories: [-1],
      formats: [-1],
      regions: [-1],
      clusters: [-1],
  };

  private competitorSelectionStates: {[competitorValue: string]: {
    isRunning: boolean;
    tasksMap: Map<number, ICompetitorSelectionTask>;
    progress: number;
    pollingInterval: number | null;
  }} = {};

  private isModalTableLoading: boolean = false;
  private selectedProductsFromModal: IProductsToLinkToCompetitor[] = [];
  private skuFilterModal: string = '';
  private isProductSelectionModalVisible: boolean = false;
  private selectedProductForModal: ICompetitorProduct | null = null;
  private selectedCompetitorProductUrl: string = '';
  private competitorSelected: ICompetitorSelected = {
      competitorCode: '',
      competitorName: '',
      format: {
          id: 0,
          name: ''
      },
      region: {
          id: 0,
          name: ''
      },
      cluster: null,
  };

  isCompetitorsSelectDataLoading: boolean = false;
  isCompetitorsSitesLoading: boolean = false;
  isSelectionDataLoading: boolean = false;
  isCompetitorLinkedProductsTableLoading: boolean = false;

  selectCompetitorOptions: ISelectCompetitorOptionsItem[] = [];
  competitorSiteOptions: SelectOption<string>[] = [];

  private setCompetitorState(competitorValue: string) {
    if (!this.competitorSelectionStates[competitorValue]) {
      Vue.set(this.competitorSelectionStates, competitorValue, {
        isRunning: false,
        tasksMap: new Map<number, ICompetitorSelectionTask>(),
        progress: 0,
        pollingInterval: null,
      });
    }
  }

  private getCompetitorState(competitorValue: string | null) {
    if (!competitorValue) return null;
    this.setCompetitorState(competitorValue);
    return this.competitorSelectionStates[competitorValue];
  }

  get isCompetitorsSelectionRunning(): boolean {
    const state = this.getCompetitorState(this.selectedCompetitorValue);
    return state ? state.isRunning : false;
  }

  get selectionTasksMap(): Map<number, ICompetitorSelectionTask> {
    const state = this.getCompetitorState(this.selectedCompetitorValue);
    return state ? state.tasksMap : new Map();
  }

  get selectionProgress(): number {
    const state = this.getCompetitorState(this.selectedCompetitorValue);
    return state ? state.progress : 0;
  }

  get selectionPollingInterval(): number | null {
    const state = this.getCompetitorState(this.selectedCompetitorValue);
    return state ? state.pollingInterval : null;
  }

  localSelectKviCart: SelectKviCart = { id: -1, kviCartName: this.$t('shared.selectBox.selectOption') as string };
  productLineOptions: Array<SelectBox<string>> = [];
  productLineOptionsForFilter: Array<SelectBox<string>> = [];
  selectProductLine: string = { value: "all", label: this.$t('shared.selectBox.all') as string }.value;

  productRangesArray: InternalCodeAndProductRange[] = [];

  skuFilterAddProductModal: string = "";

  defaultFilterValue = { value: -1, label: this.$t('shared.selectBox.all') as string };

  modalLevelFilterOptions: IModalLevelFilterCommon = {
      groups: [this.defaultFilterValue],
      categories: [this.defaultFilterValue],
      subcategories: [this.defaultFilterValue],
  };
  modalLevelFiltersSelected: IModalLevelFiltersSelected = {
      groups: [-1],
      categories: [-1],
      subcategories: [-1],
  };

  selectKVI: number = this.defaultFilterValue.value;
  selectKVIRecommends: number = this.defaultFilterValue.value;

  filterProductGroupsOptions: Array<SelectBox<number>> = [];
  filterProductCategoriesOptions: Array<SelectBox<number>> = [];
  filterProductSubcategoriesOptions: Array<SelectBox<number>> = [];

  selectFilterProductGroup: number = this.defaultFilterValue.value;
  selectFilterProductCategory: number = this.defaultFilterValue.value;
  selectFilterProductSubcategory: number = this.defaultFilterValue.value;
  selectFilterProductSegment: number = this.defaultFilterValue.value;

  sortingField: SortingField | null = null;
  sortByInternalCode: number = -1;
  sortByStoreFormat: number = -1;
  sortByStoreRegion: number = -1;
  sortBySkuName: number = -1;
  sortByCompetitorName: number = -1;
  sortByCompetitorPriority: number = -1;
  sortByLastPrice: number = -1;
  sortByPromoPrice: number = -1;
  sortByCompetitorPrice: number = -1;
  sortByDelta: number = -1;
  sortByKvi: number = -1;
  sortByCtm: number = -1;
  sortByDataIndexCharacteristicOfTheProductIsOne: number = -1;
  sortByDataIndexCharacteristicOfTheProductIsTwo: number = -1;
  sortByCompetitorDate: number = -1;

  kviOptions: Array<SelectBox<number>> = [
    { value: -1, label: this.$t('shared.selectBox.all') as string },
    { value: 1, label: "KVI" },
    { value: 0, label: this.$t('shared.selectBox.notKvi') as string },
  ];

  kviRecommendsOptions: Array<SelectBox<number>> = [
    { value: -1, label: this.$t('shared.selectBox.all') as string },
    { value: 0, label: this.$t('shared.selectBox.gk') as string },
    { value: 1, label: this.$t('shared.selectBox.cvk') as string },
  ];

  defaultCtmFilterValue = { value: "all", label: this.$t('shared.selectBox.all') as string };
  selectCTM: string = this.defaultCtmFilterValue.value;
  ctmOptions: Array<SelectBox<string>> = [
    this.defaultCtmFilterValue,
    { value: "1", label: "CTM" },
    { value: "0", label: this.$t('shared.selectBox.notCtm') as string },
  ];

  defaultIntSelectBox: Array<SelectBox<number>> = [{ value: 0, label: this.$t('shared.selectBox.all') as string }];
  defaultStringSelectBox: Array<SelectBox<string>> = [
    { value: this.$t('shared.selectBox.all') as string, label: this.$t('shared.selectBox.all') as string },
  ];

  selectSegmentPrice: Segment[] = [];
  segmentPriceOptions: Array<SelectBox<Segment>> = [];
  selectProductSegmentIdAndName: ProductSegmentIdAndName[] = [];
  productSegmentIdAndNameOptions: Array<
    SelectBox<ProductSegmentIdAndName>
  > = [];
  selectKeyCharacteristicOne: string[] = [];
  selectKeyCharacteristicTwo: string[] = [];
  selectRecipeAttributes: string[] = [];
  selectTreatmentAttributes: number[] = [];
  keyCharacteristicOneOptions: Array<SelectBox<string>> = [];
  keyCharacteristicTwoOptions: Array<SelectBox<string>> = [];
  recipeAttributesOptions: Array<SelectBox<string>> = [];
  treatmentAttributesOptions: Array<SelectBox<number>> = [];

  selectedCompetitorsCtmFilter: SelectBox<string> = this.defaultCtmFilterValue;

  selectedCompetitorsKviFilter: SelectBox<number> = this.defaultFilterValue;

  selectedMonitoringDateFilter: string[] = [];
  monitoringDateFilterOptions: Array<SelectBox<string>> = [];

  selectedDeltaFilter: string[] = [];
  deltaFilterOptions: Array<SelectBox<string>> = [];

  selectedCompetitorsPriceFilter: string[] = [];
  competitorsPriceFilterOptions: Array<SelectBox<string>> = [];

  selectedLastPriceFilter: string[] = [];
  lastPriceFilterOptions: Array<SelectBox<string>> = [];

  selectedCompetitorsPriorityFilter: string[] = [];
  competitorsPriorityFilterOptions: Array<SelectBox<string>> = [];

  selectedCompetitorsNameFilter: string[] = [];
  competitorsNameFilterOptions: Array<SelectBox<string>> = [];

  selectedSkuNameFilter: string[] = [];
  skuNameFilterOptions: Array<SelectBox<string>> = [];

  selectedKeyCharacteristicOneForCompetitors: string[] = [];
  keyCharacteristicOneForCompetitorsOptions: Array<SelectBox<string>> = [];

  selectedKeyCharacteristicTwoForCompetitors: string[] = [];
  keyCharacteristicTwoForCompetitorsOptions: Array<SelectBox<string>> = [];
  currentMainTab: string = "mainParameters";

  taskInfo: TaskInfoCalc = {
    storeFormatOptions: [{ value: null, label: this.$t('shared.selectBox.all') as string }],
    storeRegionOptions: [],
    buyerSegmentOptions: [],
    categoryOptions: [{ value: null, label: this.$t('shared.selectBox.selectCategory') as string }],
    clusterOptions: [{ value: null, label: this.$t('shared.selectBox.selectCluster') as string }],
    groupsOfProduct: [{ value: null, label: this.$t('shared.selectBox.all') as string }],
    subcategories: [],
    subcategoriesDefault: [{ value: null, label: this.$t('shared.selectBox.all') as string }],
    psegemnts: [],
  };

  taskInfoPackageKviRecommends: TaskInfoCalc = {
    storeFormatOptions: [{ value: null, label: this.$t('shared.selectBox.all') as string }],
    storeRegionOptions: [],
    buyerSegmentOptions: [],
    categoryOptions: [{ value: null, label: this.$t('shared.selectBox.selectCategory') as string }],
    clusterOptions: [{ value: null, label: this.$t('shared.selectBox.selectCluster') as string }],
    groupsOfProduct: [{ value: null, label: this.$t('shared.selectBox.all') as string }],
    subcategories: [],
    subcategoriesDefault: [{ value: null, label: this.$t('shared.selectBox.all') as string }],
    psegemnts: [],
  };
  errors = [];
  tableKey = 1;
  kviCartComponentKey = 1;
  competitorTableKey = 1;

  competitorProductLinksFile: File | null = null;
  competitorProductLinksErrorsAmount: number = 0;
  skuList: Sku[] = [];
  skuListAddProductsToCartModal: Sku[] = [];
  cartInternalCodes: string[] = [];
  skuListWithAllProducts: Sku[] = [];
  fileResult: string = "";
  taskId: number = 0;
  searchable: boolean = true;

  competitorProductsTableData: ICompetitorProduct[] = [];
  selectedCompetitorSkuList: Sku[] = [];

  skuListTableFields: any[] = [
      {dataIndex: 'selected', title: '✓', scopedSlots: { customRender: 'selected' }, width: 50},
      {dataIndex: 'internalCode', title: this.$t('shared.table.internalCode') as string, width: 100},
      {dataIndex: 'skuName', title: this.$t('shared.table.skuName') as string, width: 170, ellipsis: true},
      {dataIndex: 'productGroup', title: this.$t('shared.filters.productGroup') as string, width: 150, ellipsis: true},
      {dataIndex: 'categoryName', title: this.$t('shared.filters.productCategory') as string, width: 150, ellipsis: true},
      {dataIndex: 'subcategory', title: this.$t('shared.labels.productSubcategory') as string, width: 170, ellipsis: true},
      {dataIndex: 'productFormatName', title: this.$t('shared.table.format') as string, width: 120, scopedSlots: { filterDropdown: '', filterIcon: '' }, ellipsis: true},
      {dataIndex: 'productRegionNames', title: this.$t('shared.table.region') as string, width: 120, scopedSlots: { filterDropdown: '', filterIcon: '' }, ellipsis: true},
      {dataIndex: 'productClusterName', title: this.$t('shared.table.cluster') as string, width: 120, scopedSlots: { filterDropdown: '', filterIcon: '' }, ellipsis: true},
      {dataIndex: 'productSegmentName', title: this.$t('priceMonitoring.parsingProducts.productSegments') as string, width: 120, scopedSlots: { filterDropdown: 'segmentFilter', filterIcon: 'segmentFilterIcon' }, ellipsis: true},
      {dataIndex: 'keyCharacteristicOfTheProductIsOne', title: this.$t('priceMonitoring.parsingProducts.kht1') as string, width: 120, scopedSlots: { filterDropdown: 'kxt1Filter', filterIcon: 'kxt1FilterIcon' }, ellipsis: true},
      {dataIndex: 'keyCharacteristicOfTheProductIsTwo', title: this.$t('priceMonitoring.parsingProducts.kht2') as string, width: 120, scopedSlots: { filterDropdown: 'kxt2Filter', filterIcon: 'kxt2FilterIcon' }, ellipsis: true},
      {dataIndex: 'recipeAttribute', title: this.$t('priceMonitoring.parsingProducts.prc') as string, width: 120, scopedSlots: { filterDropdown: 'prcFilter', filterIcon: 'prcFilterIcon' }, ellipsis: true},
      {dataIndex: 'treatmentAttribute', title: this.$t('priceMonitoring.parsingProducts.pkl') as string, width: 120, scopedSlots: { filterDropdown: 'pklFilter', filterIcon: 'pklFilterIcon' }, ellipsis: true},
      {dataIndex: 'kvi', title: 'KVI', scopedSlots: { customRender: 'kvi', filterDropdown: 'kviFilter', filterIcon: 'kviFilterIcon' }, width: 80},
      {dataIndex: 'tagsKvi', title: this.$t('priceMonitoring.parsingProducts.kviTags') as string, scopedSlots: { customRender: 'tagsKvi', filterDropdown: 'tagsKviFilter', filterIcon: 'tagsKviFilterIcon' }, width: 100},
      {dataIndex: 'ctm', title: 'CTM', width: 70, scopedSlots: { filterDropdown: 'ctmFilter', filterIcon: 'ctmFilterIcon' }, ellipsis: true},
      {dataIndex: 'minMaxRetailPrice', title: this.$t('priceMonitoring.parsingProducts.minMaxRc') as string, width: 150, ellipsis: true, customRender: (value: any, item: any) => `${(item.minRetailPrice) ? this.numberFormatter(item.minRetailPrice) : '-'}/${(item.maxRetailPrice) ? this.numberFormatter(item.maxRetailPrice) : '-'}`},
      {dataIndex: 'productRange', title: this.$t('priceMonitoring.parsingProducts.productRange') as string, scopedSlots: { customRender: 'productRange', filterDropdown: 'productRangeFilter', filterIcon: 'productRangeFilterIcon' }, width: 130, ellipsis: true},
      {dataIndex: 'lastPrice', scopedSlots: { title: 'lastPriceTitle' }, width: 130, customRender: (value: any) => value ? this.numberFormatter(value) : '-', ellipsis: true},
      {dataIndex: 'priceSegment', title: this.$t('priceMonitoring.parsingProducts.priceSegment') as string, scopedSlots: { filterDropdown: 'priceSegmentFilter', filterIcon: 'priceSegmentFilterIcon' }, width: 150, ellipsis: true, customRender: (value: any, item: any) => `${(item.priceSegmentMin) ? this.numberFormatter(item.priceSegmentMin) : ''} - ${(item.priceSegmentMax) ? this.numberFormatter(item.priceSegmentMax) : ''}`},
      {dataIndex: 'lastPriceMarginPc', title: this.$t('priceMonitoring.parsingProducts.marginByLastPrice') as string, width: 150, ellipsis: true},
      {dataIndex: 'actualProfitability', scopedSlots: { title: 'actualProfitabilityTitle' }, width: 120, ellipsis: true, customRender: (value: any) => this.numberFormatter(value)},
      {
          dataIndex: 'productVolume',
          title: this.$t('priceMonitoring.parsingProducts.vgh') as string,
          customRender: (value: any) => this.numberFormatter(value),
          ellipsis: false,
          width: 40,
      },
      {
          dataIndex: 'measurementUnit',
          title: this.$t('priceMonitoring.parsingProducts.measureUnit') as string,
          ellipsis: false,
          width: 35,
      },
      {
          dataIndex: 'productVerticalLine',
          title: this.$t('priceMonitoring.parsingProducts.vlName') as string,
          ellipsis: true,
          width: 75,
      },
      {
          dataIndex: 'isVerticalLineBase',
          title: this.$t('priceMonitoring.parsingProducts.base') as string,
          customRender: (value: any) => value != null ? this.toYesOrNo(value) : '',
          ellipsis: false,
          width: 60,
      },
      {
          dataIndex: 'vlStrategyStr',
          title: this.$t('priceMonitoring.parsingProducts.vlStrategy') as string,
          ellipsis: false,
          width: 75,
      },
      {
          dataIndex: 'vlGapPc',
          title: this.$t('priceMonitoring.parsingProducts.vlGapPc') as string,
          customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
          ellipsis: false,
          width: 140,
      },
  ];

  isCommonCheckboxSelected: boolean = false;
  includedIds: number[] = [];
  excludedIds: number[] = [];

  competitorProductsTableFields: any[] = [
    {
      key: 'checkboxes',
      scopedSlots: {
        title: 'commonCheckbox',
        customRender: 'rowCheckbox',
      },
      width: 15,
    },
    {
      dataIndex: "internalCode",
      title: this.$t('shared.table.internalCode') as string,
      filterOptionsKey: 'internalCode',
      filterModelKey: 'internalCodes',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      sorter: true,
      width: 100,
    },
    {
      dataIndex: "skuName",
      title: "SKU",
      filterOptionsKey: 'skuName',
      filterModelKey: 'skuNames',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      sorter: true,
      width: 150,
      ellipsis: true,
    },
    {
      dataIndex: "storeFormat.name",
      title: this.$t('shared.table.format') as string,
      sorter: true,
      width: 70,
      ellipsis: true,
    },
    {
      dataIndex: "storeRegion.name",
      title: this.$t('shared.table.region') as string,
      sorter: true,
      width: 70,
      ellipsis: true,
    },
    {
      dataIndex: "storeCluster.name",
      title: this.$t('shared.table.cluster') as string,
      sorter: true,
      width: 70,
      ellipsis: true,
    },
    {
      dataIndex: "parsingUrl",
      title: this.$t('priceMonitoring.parsingProducts.competitorLink') as string,
      width: 160,
      ellipsis: true,
      sorter: true,
      scopedSlots: { customRender: "parsingUrl" },
    },
    {
      dataIndex: "lastParsingDateTime",
      title: this.$t('shared.table.date') as string,
      width: 80,
      ellipsis: true,
      scopedSlots: { customRender: "lastParsingDateTime" },
      sorter: true,
    },
    // { dataIndex: "batchNumber", title: this.$t('parsingProducts.columns.batchNumber') as string, width: 80 },
    {
      dataIndex: "group.name",
      title: this.$t('shared.filters.productGroup') as string,
      filterOptionsKey: 'group',
      filterModelKey: 'groupIds',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      sorter: true,
      width: 150,
      ellipsis: true,
    },
    {
      dataIndex: "category.name",
      title: this.$t('shared.filters.productCategory') as string,
      filterOptionsKey: 'category',
      filterModelKey: 'categoryIds',
      scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      sorter: true,
      width: 150,
      ellipsis: true,
    },
    {
      dataIndex: "subcategory.name",
      title: this.$t('shared.labels.productSubcategory') as string,
      width: 170,
      // filterOptionsKey: 'subcategory',
      // filterModelKey: 'subcategoryIds',
      // scopedSlots: {filterDropdown: 'filterCheckboxes', filterIcon: "filterIcon"},
      sorter: true,
      ellipsis: true,
    },
    {
      dataIndex: "productSegmentName",
      title: this.$t('priceMonitoring.parsingProducts.productSegments') as string,
      width: 120,
      sorter: true,
      ellipsis: true,
    },
    {
      dataIndex: "keyCharacteristicOne",
      title: this.$t('priceMonitoring.parsingProducts.kht1') as string,
      width: 120,
      sorter: true,
      ellipsis: true,
    },
    {
      dataIndex: "keyCharacteristicTwo",
      title: this.$t('priceMonitoring.parsingProducts.kht2') as string,
      width: 120,
      sorter: true,
      ellipsis: true,
    },
    {
      dataIndex: "recipeAttribute",
      title: this.$t('priceMonitoring.parsingProducts.prc') as string,
      width: 120,
      sorter: true,
      ellipsis: true,
    },
    {
      dataIndex: "treatmentAttribute",
      title: this.$t('priceMonitoring.parsingProducts.pkl') as string,
      width: 120,
      sorter: true,
      ellipsis: true,
    },
    {
      dataIndex: "kvi",
      title: "KVI",
      width: 80,
      sorter: true,
    },
    {
      dataIndex: "tagsKvi",
      title: "",
      scopedSlots: {
        customRender: "tagsKvi",
      },
      width: 100,
    },
    {
      dataIndex: "ctm",
      title: "CTM",
      width: 70,
      ellipsis: true,
    },
    {
      dataIndex: "minMaxRetailPrice",
      title: this.$t('priceMonitoring.parsingProducts.minMaxRc') as string,
      width: 150,
      ellipsis: true,
      customRender: (value: any, item: any) =>
        `${
          item.minRetailPrice ? this.numberFormatter(item.minRetailPrice) : "-"
        }/${
          item.maxRetailPrice ? this.numberFormatter(item.maxRetailPrice) : "-"
        }`,
    },
    {
      dataIndex: "productRange",
      title: this.$t('priceMonitoring.parsingProducts.productRange') as string,
      width: 130,
      ellipsis: true,
    },
    {
      dataIndex: "lastPrice",
      scopedSlots: { title: "lastPriceTitle" },
      width: 130,
      customRender: (value: any) => (value ? this.numberFormatter(value) : "-"),
      ellipsis: true,
    },
    {
      dataIndex: "priceSegment",
      title: this.$t('priceMonitoring.parsingProducts.priceSegment') as string,
      width: 150,
      ellipsis: true,
      customRender: (value: any, item: any) =>
        `${
          item.priceSegmentMin ? this.numberFormatter(item.priceSegmentMin) : ""
        } - ${
          item.priceSegmentMax ? this.numberFormatter(item.priceSegmentMax) : ""
        }`,
    },
    {
      dataIndex: "productVolume",
      title: this.$t('priceMonitoring.parsingProducts.vgh') as string,
      customRender: (value: any) => this.numberFormatter(value),
      ellipsis: false,
      width: 40,
    },
    {
      dataIndex: "measurementUnit",
      title: this.$t('priceMonitoring.parsingProducts.measureUnit') as string,
      ellipsis: false,
      width: 35,
    },
    {
      dataIndex: "productVerticalLine",
      title: this.$t('priceMonitoring.parsingProducts.vlName') as string,
      ellipsis: true,
      width: 75,
    },
  ];

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
  };
  sortingData: any = {
      field: 'id',
      order: 'desc',
  }

  paginationInModal: any = {
    pageSize: 20,
    current: 1,
    total: 0,
  };

  competitors: CompetitorsPriceRow[] = [];
  viewCompetitors: CompetitorsPriceRow[] = [];
  skuListLimit: number = 20;
  skuFilter: string = "";
  debounceMinRetailPrice!: () => void;
  serverConfigTimeout: number | null = null;
  loadingConfigs = false;
  marginalErrorText = "";
  globalIndividualMarginalErrorText = "";
  globalIndividualMarginalBlockButton = false;
  globalIndividualPeriodPriceIncreaseLimitBlockButton = false;
  globalIndividualPriceIncreaseLimitBlockButton = false;
  marginalSkuErrorText = "";

  taskData: TaskAndFile | null = null;
  skuListPerPage: number = 20;
  skuListCurrentPage: number = 1;
  skuListTotalRows: number = 0;
  calcSkuLastPricesButtonDisabled: boolean = false;
  calcSkuActualProfitButtonDisabled: boolean = false;
  firstDate: number = 0;
  lastDate: number = 0;
  showBookmarks: boolean = true;
  showMainFilters: boolean = true;
  needLoadSkuList = false;
  isActualProfitabilityCalculated: boolean = false;
  isRegularPricesProfitabilityCalculated: boolean = false;
  isDataRangeCalculated: boolean = false;
  isFetchSkuListDownload: boolean = false;
  isLoadCompetitorPrices: boolean = false;
  kviSaveProcess: boolean = false;
  useFindKviRecommendsParam: boolean = false;
  tabs: BTabs | null = null;
  showSkuAndSearch: boolean = true;
  private refreshSkuListId = -1;
  private refreshTabPanelSkuListId = -1;

  private skuListWithCalculating: boolean = false;
  private sortBySKU: number = -1;
  private dropDownOpen = false;
  // tslint:disable-next-line: ban-types
  private onDropdownClosed: Function | null = null;
  private actualProfitability: number | null = null;
  private regularPricesProfitability: number | null = null;
  private isFiltersChanged = 1;
  private productCodesForAddKvi: string[] = [];
  private productCodesForDeleteKvi: string[] = [];
  private productCodesForAddCtmPurpose: string[] = [];
  private needCalculateSkuLastPricesOnly: boolean = false;
  private needCalculateSkuActualProfitabilityOnly: boolean = false;

  numberFormatter = (v: any): string => FormatNumber.format(v);

  mounted() {
    this.isSelectionDataLoading = true;

    this.tabs = this.$refs.mainTabs as BTabs;
    this.$kviCart.kviCartChangePrices = kviCartChangePricesSb.ALL_CART_PRICES;
    if (this.$kviCart.selectMarket.id !== -1) {
      const self = this;
      self.getRegionInfo();
      self.getFormatInfo();
      self.getClusterInfo();
      self.getGroupInfo();
      self.getCategoryInfo();
      self.getSubcategoryInfo();
      self.getSegmentInfo();
    }

    this.fetchCompetitorsDataForSelect();
    this.fetchCompetitorSites();
    this.getCompetitorProductLinksErrorsAmount();
  }

  private fetchCompetitorsDataForSelect() {
    this.isCompetitorsSelectDataLoading = true;

    this.httpFetchCompetitorsList(this.currentTradingId, {
        current: 1,
        pageSize: 1000,
    }).then((response) => {
        const array: ISelectCompetitorOptionsItem[] = [];

        response.data.content.forEach((competitor: any) => {
            array.push({
                label: competitor.competitorName,
                value: `${competitor.competitorCode}-${competitor.competitorFormat.id}-${competitor.competitorRegion.id}-${competitor.competitorCluster ? competitor.competitorCluster.id : ''}` ,
                competitorCode: competitor.competitorCode,
                competitorName: competitor.competitorName,
                competitorFormat: competitor.competitorFormat,
                competitorRegion: competitor.competitorRegion,
                competitorCluster: competitor.competitorCluster,
                lastParsingSearchSite: competitor.lastParsingSearchSite,
            })
        });

        this.selectCompetitorOptions = [...array];

        if (localStorage.getItem('compDirectorySelectedCompetitor')) {
            const localstorageCompetitorData: ILocalstorageCompetitorData = this.parseCompetitorData(localStorage.getItem('compDirectorySelectedCompetitor')!)

            const competitor = this.selectCompetitorOptions.find((competitorOptionsItem: ISelectCompetitorOptionsItem) => {
                const isClusterEqual = (!localstorageCompetitorData.clusterId && !competitorOptionsItem.competitorCluster) || !!(localstorageCompetitorData.clusterId
                    && (competitorOptionsItem.competitorCluster && competitorOptionsItem.competitorCluster.id === Number(localstorageCompetitorData.clusterId)))

                return competitorOptionsItem.competitorCode === localstorageCompetitorData.code && competitorOptionsItem.competitorFormat.id === Number(localstorageCompetitorData.formatId)
                    && competitorOptionsItem.competitorRegion.id === Number(localstorageCompetitorData.regionId) && isClusterEqual;
            })

            if (competitor) {
                this.competitorSelected = JSON.parse(JSON.stringify({
                    ...competitor,
                    format: competitor.competitorFormat,
                    region: competitor.competitorRegion,
                    cluster: competitor.competitorCluster,
                }));

                this.selectedCompetitorValue = competitor.value;

                this.setSelectedSite(competitor.lastParsingSearchSite);

                this.fetchCompetitorLinkedProducts();
                this.fetchCompetitorLinkedProductsTableOptions();
            } else {
                this.isSelectionDataLoading = false;

                localStorage.removeItem('compDirectorySelectedCompetitor');
            }
        } else {
            this.isSelectionDataLoading = false;
        }
    }).catch(() => {
        this.selectCompetitorOptions = [];
    }).finally(() => {
        this.isCompetitorsSelectDataLoading = false;
    });
  }

  private fetchCompetitorSites() {
      this.isCompetitorsSitesLoading = true;

      this.httpFetchCompetitorDomains().then((response) => {
          this.competitorSiteOptions = response.data.map(domain => ({ label: domain, value: domain }));
      }).finally(() => {
          this.isCompetitorsSitesLoading = false;
      });
  }

  mockedListLinksSuggestions = [
    {
      title: this.$t('priceMonitoring.parsingProducts.position1') as string,
      link: "https://www.auchan.ru/",
    },
    {
      title: this.$t('priceMonitoring.parsingProducts.position2') as string,
      link: "https://dobronom.by/",
    },
    {
      title: this.$t('priceMonitoring.parsingProducts.position3') as string,
      link: "https://kopeechka.by/",
    },
    {
      title: this.$t('priceMonitoring.parsingProducts.position4') as string,
      link: "https://mayakgm.ru/",
    },
  ];

  @Watch("selectedCompetitorValue")
  selectedCompetitorValueChanged() {
    this.pagination.current = 1;
    this.pagination.total = 0;
    this.competitorProductsTableData = [];

    this.selectedCompetitorSkuList = [];
  }

  @Watch('isLinkProductsModalVisible')
  modalVisibleChanged(value: boolean) {
      if (value) {
          if (this.modalLevelFilterOptions.groups.length < 2) {
              this.requestCommonFilter('groups');
          }

          if (!this.skuListAddProductsToCartModal.length) {
              this.fetchFullSkuList();
          }
      }
  }

  closeLinksSuggestionsModal() {
    this.$bvModal.hide("listLinksSuggestionsModal");
  }

  momentDayNow() {
    return moment(new Date()).format("DD.MM.YYYY");
  }

  copyToClipboard(text: string) {
    const el = document.createElement("textarea");
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
  }

  onSkuTableChange(pagination: any, filters: any, sorter: any) {
      this.pagination = { ...pagination };

      if (sorter.field && sorter.order) {
          this.sortingData = {
              field: sorter.field,
              order: sorter.order === 'descend' ? 'desc' : 'asc',
          }
      } else {
          this.sortingData = {
              field: 'id',
              order: 'desc',
          }
      }

      this.fetchCompetitorLinkedProducts();
  }

  onSkuTableModalChange(pagination: any, filters: any, sorter: any) {
    this.paginationInModal = { ...pagination };
    if ((sorter.field = "skuName")) {
      this.sortBySKU = sorter.order === "ascend" ? 1 : -1;
    }
    this.fetchFullSkuList();
  }

  onCalcEventReceived(data: TaskData) {
    if (this.showCalcProgress(data.status)) {
    }
  }

  beforeDestroy() {
    this.$calc.hintsLoaded = false;
    this.$calc.currentModuleHints = [];

    this.stopAllSelectionPolling();
  }

  created() {
    this.httpLoadModuleHints("KviShoppingCart")
      .then((r) => {
        this.$calc.currentModuleHints = r.data;
        this.$calc.hintsLoaded = true;
      })
      .catch((e) => {});
    if (this.$disallowedModules.includes("kviShoppingCart")) {
      this.$router.replace("/calc");
    }
  }

  resetActualProfitability() {
    this.actualProfitability = null;
  }

  resetRegularPricesProfitability() {
    this.regularPricesProfitability = null;
  }

  resetData(type: TaskInfoFilterType) {
    switch (type) {
      case TaskInfoFilterType.group:
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
        this.sortBySKU = -1;
        this.$kviCart.categoryOfProduct = null;
        this.$kviCart.subcategory = null;
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.categoryOptions = [];
        this.taskInfo.subcategories = [];
        this.taskInfo.clusterOptions = [
          { value: null, label: this.$t('shared.selectBox.selectCluster') as string },
        ];
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = false;
        this.calcSkuActualProfitButtonDisabled = false;
        this.getCategoryInfo();
        this.getSubcategoryInfo();
        this.getSegmentInfo();
        this.isFiltersChanged = 1;
        this.hideSkuPanel();
        this.filterProductGroupsOptions = [];
        this.filterProductCategoriesOptions = [];
        this.filterProductSubcategoriesOptions = [];
        this.productCodesForAddKvi = [];
        this.productCodesForDeleteKvi = [];
        this.segmentPriceOptions = [];
        this.productSegmentIdAndNameOptions = [];
        this.resetCompetitors();
        break;
      case TaskInfoFilterType.category:
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
        this.sortBySKU = -1;
        this.$kviCart.subcategory = null;
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.subcategories = [];
        this.taskInfo.clusterOptions = [
          { value: null, label: this.$t('shared.selectBox.selectCluster') as string },
        ];
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = false;
        this.calcSkuActualProfitButtonDisabled = false;
        this.getSubcategoryInfo();
        this.getSegmentInfo();
        this.isFiltersChanged = 1;
        this.hideSkuPanel();
        this.filterProductGroupsOptions = [];
        this.filterProductCategoriesOptions = [];
        this.filterProductSubcategoriesOptions = [];
        this.productCodesForAddKvi = [];
        this.productCodesForDeleteKvi = [];
        this.segmentPriceOptions = [];
        this.productSegmentIdAndNameOptions = [];
        this.resetCompetitors();
        break;
      case TaskInfoFilterType.subcategory:
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
        this.sortBySKU = -1;
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.clusterOptions = [
          { value: null, label: this.$t('shared.selectBox.selectCluster') as string },
        ];
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = false;
        this.calcSkuActualProfitButtonDisabled = false;
        this.getSegmentInfo();
        this.isFiltersChanged = 1;
        this.hideSkuPanel();
        this.filterProductGroupsOptions = [];
        this.filterProductCategoriesOptions = [];
        this.productCodesForAddKvi = [];
        this.productCodesForDeleteKvi = [];
        this.segmentPriceOptions = [];
        this.productSegmentIdAndNameOptions = [];
        this.resetCompetitors();
        break;
      case TaskInfoFilterType.p_segemnt:
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
        this.sortBySKU = -1;
        this.$kviCart.regionSelected = this.defaultIntSelectBox.map(
          (i) => i.value
        );
        this.$kviCart.clusterSelected = [];
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.clusterOptions = [
          { value: null, label: this.$t('shared.selectBox.selectCluster') as string },
        ];
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = false;
        this.calcSkuActualProfitButtonDisabled = false;
        this.isFiltersChanged = 1;
        this.hideSkuPanel();
        this.filterProductGroupsOptions = [];
        this.filterProductCategoriesOptions = [];
        this.productCodesForAddKvi = [];
        this.productCodesForDeleteKvi = [];
        this.segmentPriceOptions = [];
        this.productSegmentIdAndNameOptions = [];
        this.resetCompetitors();
        break;
      case TaskInfoFilterType.format:
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
        this.sortBySKU = -1;
        this.$kviCart.regionSelected = this.defaultIntSelectBox.map(
          (i) => i.value
        );
        this.$kviCart.clusterSelected = [];
        this.taskInfo.storeRegionOptions = [];
        this.taskInfo.clusterOptions = [
          { value: null, label: this.$t('shared.selectBox.selectCluster') as string },
        ];
        this.needLoadSkuList = false;
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = false;
        this.calcSkuActualProfitButtonDisabled = false;
        this.getRegionInfo();
        this.getClusterInfo();
        this.isFiltersChanged = 1;
        this.hideSkuPanel();
        this.filterProductGroupsOptions = [];
        this.filterProductCategoriesOptions = [];
        this.filterProductSubcategoriesOptions = [];
        this.productCodesForAddKvi = [];
        this.productCodesForDeleteKvi = [];
        this.segmentPriceOptions = [];
        this.productSegmentIdAndNameOptions = [];
        this.resetCompetitors();
        break;
      case TaskInfoFilterType.region:
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
        this.sortBySKU = -1;
        this.$kviCart.clusterSelected = [];
        this.taskInfo.clusterOptions = [
          { value: null, label: this.$t('shared.selectBox.selectCluster') as string },
        ];
        this.needLoadSkuList = false;
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = false;
        this.calcSkuActualProfitButtonDisabled = false;
        this.getClusterInfo();
        this.isFiltersChanged = 1;
        this.hideSkuPanel();
        this.filterProductGroupsOptions = [];
        this.filterProductCategoriesOptions = [];
        this.filterProductSubcategoriesOptions = [];
        this.productCodesForAddKvi = [];
        this.productCodesForDeleteKvi = [];
        this.segmentPriceOptions = [];
        this.productSegmentIdAndNameOptions = [];
        this.resetCompetitors();
        break;
      case TaskInfoFilterType.cluster:
        this.tableKey = Math.random();
        this.competitorTableKey = Math.random();
        this.sortBySKU = -1;
        this.isFiltersChanged = 1;
        this.needLoadSkuList = false;
        this.needCalculateSkuLastPricesOnly = false;
        this.needCalculateSkuActualProfitabilityOnly = false;
        this.calcSkuLastPricesButtonDisabled = false;
        this.calcSkuActualProfitButtonDisabled = false;
        this.hideSkuPanel();
        this.filterProductGroupsOptions = [];
        this.filterProductCategoriesOptions = [];
        this.filterProductSubcategoriesOptions = [];
        this.productCodesForAddKvi = [];
        this.productCodesForDeleteKvi = [];
        this.segmentPriceOptions = [];
        this.productSegmentIdAndNameOptions = [];
        this.resetCompetitors();
    }
    this.keyCharacteristicOneOptions = [];
    this.keyCharacteristicTwoOptions = [];
    this.recipeAttributesOptions = [];
    this.treatmentAttributesOptions = [];
    this.resetActualProfitability();
    this.resetRegularPricesProfitability();
    this.taskId = 0;
    this.fileResult = "";
    this.skuListWithCalculating = false;
  }

  resetCompetitors() {
    this.selectedSkuNameFilter = [];
    this.selectedCompetitorsNameFilter = [];
    this.selectedCompetitorsPriorityFilter = [];
    this.selectedLastPriceFilter = [];
    this.selectedCompetitorsPriceFilter = [];
    this.selectedDeltaFilter = [];
    this.selectedCompetitorsKviFilter = this.defaultFilterValue;
    this.selectedCompetitorsCtmFilter = this.defaultCtmFilterValue;
    this.selectedKeyCharacteristicOneForCompetitors = [];
    this.selectedKeyCharacteristicTwoForCompetitors = [];
    this.selectedMonitoringDateFilter = [];
  }

  resetDataRange() {
    this.firstDate = 0;
    this.lastDate = 0;
  }

  resetKVIparams() {
    this.useFindKviRecommendsParam = false;
    this.$kviCart.percentageOfRecommendsKviCount = 10;
    this.$kviCart.useSegmentsPriceInSearchKVIRecParam = false;
    this.$kviCart.saveKviSign = false;
  }

  showCalcProgress(status: string): boolean {
    return (
      status === "WriteToFileComplete" ||
      status === "EmptyData" ||
      status === "ExecutionException" ||
      status.includes("Error")
    );
  }

  selectData(): [
    number[],
    number[],
    number[],
    number[],
    number[],
    string | null,
    Segment[] | null
  ] {
    const selectRegions: number[] =
      this.$kviCart.regionSelected.length === 0 ||
      (this.$kviCart.regionSelected.length &&
        this.$kviCart.regionSelected[0] === 0)
        ? []
        : // tslint:disable-next-line: no-non-null-assertion
          LocalData.filterNumberArrays(this.$kviCart.regionSelected)!!;
    const selectGroups: number[] =
      this.$kviCart.groupsOfProduct.length === 0 ||
      (this.$kviCart.groupsOfProduct.length &&
        this.$kviCart.groupsOfProduct[0] === 0)
        ? []
        : // tslint:disable-next-line: no-non-null-assertion
          LocalData.filterNumberArrays(this.$kviCart.groupsOfProduct)!!;
    const selectCategories: number[] =
      this.$kviCart.categories.length === 0 ||
      (this.$kviCart.categories.length && this.$kviCart.categories[0] === 0)
        ? []
        : // tslint:disable-next-line: no-non-null-assertion
          LocalData.filterNumberArrays(this.$kviCart.categories)!!;
    const selectSubcategories: number[] =
      this.$kviCart.subcategories.length === 0 ||
      (this.$kviCart.subcategories.length &&
        this.$kviCart.subcategories[0] === 0)
        ? []
        : // tslint:disable-next-line: no-non-null-assertion
          LocalData.filterNumberArrays(this.$kviCart.subcategories)!!;
    const selectSegments: number[] =
      this.$kviCart.productSegments.length === 0 ||
      (this.$kviCart.productSegments.length &&
        this.$kviCart.productSegments[0] === 0)
        ? []
        : // tslint:disable-next-line: no-non-null-assertion
          LocalData.filterNumberArrays(this.$kviCart.productSegments)!!;
    const ctm: string | null = this.selectCTM === "all" ? null : this.selectCTM;
    this.selectSegmentPrice = this.selectSegmentPrice.filter((item) => {
      return item.name !== "All";
    });

    const priceSegments: Segment[] | null = this.selectSegmentPrice.map((i) => {
      return {
        name: i.name,
        minSegment: i.minSegment,
        maxSegment: i.maxSegment,
      };
    });
    if (this.selectFilterProductGroup != -1) {
      selectGroups.push(this.selectFilterProductGroup);
    }
    if (this.selectFilterProductCategory != -1) {
      selectCategories.push(this.selectFilterProductCategory);
    }
    if (this.selectFilterProductSubcategory != -1) {
      selectSubcategories.push(this.selectFilterProductSubcategory);
    }
    if (this.selectFilterProductSegment != -1) {
      selectSegments.push(this.selectFilterProductSegment);
    }
    return [
      selectRegions,
      selectGroups,
      selectCategories,
      selectSubcategories,
      selectSegments,
      ctm,
      priceSegments,
    ];
  }

  kviRecommendsSelectData(): [number[], number[], number[], number[]] {
    const selectSeasons: number[] =
      this.$packageKviRecommends.seasonSelected.length === 0 ||
      (this.$packageKviRecommends.seasonSelected.length === 1 &&
        this.$packageKviRecommends.seasonSelected[0] === 0)
        ? []
        : // tslint:disable-next-line: no-non-null-assertion
          LocalData.filterNumberArrays(
            this.$packageKviRecommends.seasonSelected
          )!!;
    const selectRegions: number[] =
      this.$packageKviRecommends.regionSelected.length === 0 ||
      (this.$packageKviRecommends.regionSelected.length &&
        this.$packageKviRecommends.regionSelected[0] === 0)
        ? []
        : // tslint:disable-next-line: no-non-null-assertion
          LocalData.filterNumberArrays(
            this.$packageKviRecommends.regionSelected
          )!!;
    const selectBuyerSegment: number[] =
      this.$packageKviRecommends.buyerSegmentsList.length === 0 ||
      (this.$packageKviRecommends.buyerSegmentsList.length &&
        this.$packageKviRecommends.buyerSegmentsList[0] === 0)
        ? []
        : // tslint:disable-next-line: no-non-null-assertion
          LocalData.filterNumberArrays(
            this.$packageKviRecommends.buyerSegmentsList
          )!!;
    const selectFormats: number[] =
      this.$packageKviRecommends.formatSelected.length === 0 ||
      (this.$packageKviRecommends.formatSelected.length &&
        this.$packageKviRecommends.formatSelected[0] === 0)
        ? []
        : // tslint:disable-next-line: no-non-null-assertion
          LocalData.filterNumberArrays(
            this.$packageKviRecommends.formatSelected
          )!!;
    return [selectSeasons, selectRegions, selectBuyerSegment, selectFormats];
  }

  getRegionInfo() {
    this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
      .then((data) => {
        const filterData = data.data;
        setTimeout(() => {
          (this.$refs.updateRegionsRef as any).toggleLoading(false);
        }, 500);

        this.taskInfo.storeRegionOptions = filterData.storeRegion.map((i) => {
          return { value: i.id, label: i.name };
        });
      })
      .catch((e) => {});
  }

  getFormatInfo() {
    this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
      .then((data) => {
        const filterData = data.data;
        setTimeout(() => {
          (this.$refs.formatSelectedRef as any).toggleLoading(false);
        }, 500);

        this.taskInfo.storeFormatOptions = filterData.storeFormat.map((i) => {
          return { value: i.id, label: i.name };
        });

        this.taskInfo.storeFormatOptions = [
          {
            value: null,
            label: this.$t('shared.selectBox.all') as string,
          },
          ...this.taskInfo.storeFormatOptions,
        ];
      })
      .catch((e) => {});
  }

  getGroupInfo() {
    this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
      .then((data) => {
        const filterData = data.data;

        this.taskInfo.groupsOfProduct = filterData.groups.map((i) => {
          return { value: i.id, label: i.name };
        });
      })
      .catch((e) => {});
  }

  getCategoryInfo() {
    this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
      .then((data) => {
        const filterData = data.data;

        this.taskInfo.categoryOptions = filterData.categories.map((i) => {
          return { value: i.id, label: i.name };
        });
      })
      .catch((e) => {});
  }

  getSubcategoryInfo() {
    this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
      .then((data) => {
        const filterData = data.data;

        this.taskInfo.subcategories = filterData.subcategories.map((i) => {
          return { value: i.id, label: i.name };
        });
      })
      .catch((e) => {});
  }

  getSegmentInfo() {
    this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.p_segemnt))
      .then((data) => {
        const filterData = data.data;

        this.taskInfo.psegemnts = filterData.psegments.map((i) => {
          return { value: i.id, label: i.name };
        });
      })
      .catch((e) => {});
  }

  getKviRecommendsFormatInfo() {
    this.httpGetProductInfo(
      this.getKviRecommendsTaskInfo(TaskInfoFilterType.format)
    )
      .then((data) => {
        const filterData = data.data;
        setTimeout(() => {
          (this.$refs.kviRecommendsFormatSelectedRef as any).toggleLoading(
            false
          );
        }, 500);
        this.taskInfoPackageKviRecommends.storeFormatOptions = filterData.storeFormat.map(
          (i) => {
            return { value: i.id, label: i.name };
          }
        );
      })
      .catch((e) => {});
  }

  getKviRecommendsBuyerSegment() {
    this.httpGetProductInfo(
      this.getKviRecommendsTaskInfo(TaskInfoFilterType.buyer)
    )
      .then((data) => {
        const filterData = data.data;
        setTimeout(() => {
          (this.$refs.updateKviRecommendsBuyerSegmentsRef as any).toggleLoading(
            false
          );
        }, 500);

        this.taskInfoPackageKviRecommends.buyerSegmentOptions = filterData.buyerSegments.map(
          (i) => {
            return { value: i.id, label: i.name };
          }
        );
      })
      .catch((e) => {});
  }

  getClusterInfo() {
    this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
      .then((data) => {
        const filterData = data.data;
        setTimeout(() => {
          (this.$refs.clasterSelectedRef as any).toggleLoading(false);
        }, 500);

        this.taskInfo.clusterOptions = filterData.storeCluster.map((i) => {
          return { value: i.id, label: i.name };
        });
        this.taskInfo.clusterOptions = [
          {
            value: null,
            label: this.$t('shared.selectBox.all') as string,
          },
          ...this.taskInfo.clusterOptions,
        ];
      })
      .catch((e) => {});
  }

  getKviRecommendsClusterInfo() {
    this.httpGetProductInfo(
      this.getKviRecommendsTaskInfo(TaskInfoFilterType.cluster)
    )
      .then((data) => {
        const filterData = data.data;
        setTimeout(() => {
          (this.$refs.kviRecommendsClusterSelectedRef as any).toggleLoading(
            false
          );
        }, 500);

        this.taskInfoPackageKviRecommends.clusterOptions = filterData.storeCluster.map(
          (i) => {
            return { value: i.id, label: i.name };
          }
        );
      })
      .catch((e) => {});
  }

  prepareIndividualConfig(config: IndividualConfig): CalcIndividualConfig {
    const prepared: CalcIndividualConfig = {};

    if (
      "kviStrategy" in config &&
      typeof config.kviStrategy !== "undefined" &&
      config.kviStrategy !== null
    ) {
      prepared.kviStrategy = config.kviStrategy.value;
    }

    if (
      "marginalProfit" in config &&
      typeof config.marginalProfit !== "undefined" &&
      config.marginalProfit !== null
    ) {
      prepared.marginalProfit = config.marginalProfit;
    }

    if (
      "priceChangeLimit" in config &&
      typeof config.priceChangeLimit !== "undefined" &&
      config.priceChangeLimit !== null
    ) {
      prepared.priceChangeLimit = config.priceChangeLimit;
    }

    if (
      "selectCoefficent" in config &&
      typeof config.selectCoefficent !== "undefined" &&
      config.selectCoefficent !== null
    ) {
      const coef = config.selectCoefficent;
      prepared.coefficientK1 = coef.value.k1;
      prepared.coefficientK2 = coef.value.k2;
      prepared.priceOpt = coef.value.enum;
    }

    if (
      "priceIncreaseLimit" in config &&
      typeof config.priceIncreaseLimit !== "undefined" &&
      config.priceIncreaseLimit !== null
    ) {
      prepared.priceIncreaseLimit = config.priceIncreaseLimit;
    }

    if (
      "competitorsPricesParams" in config &&
      typeof config.competitorsPricesParams !== "undefined" &&
      config.competitorsPricesParams !== null
    ) {
      prepared.competitorsPricesParams = config.competitorsPricesParams;
    }

    if ("percentageOfCompetitorsPrice" in config) {
      prepared.percentageOfCompetitorsPrice =
        config.percentageOfCompetitorsPrice;
    }

    if (
      "periodPriceIncreaseLimit" in config &&
      typeof config.periodPriceIncreaseLimit !== "undefined" &&
      config.periodPriceIncreaseLimit !== null
    ) {
      prepared.periodPriceIncreaseLimit = config.periodPriceIncreaseLimit;
    }

    if (
      "period" in config &&
      typeof config.period !== "undefined" &&
      config.period !== null
    ) {
      prepared.period = config.period.value;
    }

    return prepared;
  }

  async calcPackageKviCarts() {
    this.showInfo(this.$t('kviCarts.messages.calcStarted') as string);
    if (
      this.$kviCart.competitorsCodes.length === 0 &&
      this.$kviCart.useCompetitorsPrices
    ) {
      const competitorFilter = this.getCompetitorsFilter();
      competitorFilter.category = -1;
      await this.httpLoadKviCartCompetitorsPrice(competitorFilter)
        .then((r) => {
          if (r.data.content.length > 0) {
            this.competitors = r.data.content.map(this.toRow);
            this.$kviCart.competitorsCodes = this.competitors.map((i) => {
              return i.internalCode;
            });
          }
        })
        .catch((e) => {
          this.showError(this.$t('priceMonitoring.competitorsPrice.errorLoadPrices') as string);
        });
    }
    const config = this.getPackageCalcConfig();
    this.saveKviShoppingCart();
    this.httpPostAddPackageKviCartTask(config)
      .then((r) => {
        this.$log.debug("Create kvi cart package task", r.data);
      })
      .catch((e) => {
        this.showError(this.$t('priceMonitoring.parsingProducts.errorStartCalc') as string);
        this.$log.error("Error occurred on creating kvi cart calc", e);
      });
  }

  hideSkuPanel() {
    this.clearFilters();
  }

  loadSkuWithoutCalc() {
    this.skuListWithCalculating = false;
    this.needLoadSkuList = true;
  }

  loadSkuWithoutCalcModal() {
    this.skuListWithCalculating = false;
    this.needLoadSkuList = true;
    this.fetchFullSkuList();
  }

  fetchFullSkuList(currentPage?: number) {
      if (this.currentTradingId === -1) {
          return;
      }

      const filter = this.getSkuModalFilter();

      const offset = ((this.paginationInModal.current || currentPage) - 1) * this.paginationInModal.pageSize;

      this.isModalTableLoading = true;

      this.httpGetSkuList(filter, this.paginationInModal.pageSize, offset)
          .then(async (r) => {
                  this.skuListAddProductsToCartModal = r.data.content;
                  this.paginationInModal.total = r.data.totalElements;
              },
          ).catch((e) => {
              this.skuListAddProductsToCartModal = [];
          }).finally(() => {
              this.isModalTableLoading = false;
          });
  }

  fetchCompetitorLinkedProductsTableOptions() {
      if (this.currentTradingId === -1) {
          return;
      }

      this.httpFetchCompetitorLinkedProductsTableOptions({
              tradingId: this.currentTradingId,
              competitorCode: this.competitorSelected.competitorCode,
              competitorName: this.competitorSelected.competitorName,
              storeFormatId: this.competitorSelected.format.id,
              storeRegionId: this.competitorSelected.region.id,
              storeClusterId: (this.competitorSelected.cluster && this.competitorSelected.cluster.id) || null,
          }).then((r) => {
              this.linkedProductsTableOptions = r.data.fields;
          }).catch(() => {
              this.linkedProductsTableOptions = {
                  competitorCode: [],
                  group: [],
                  category: [],
                  subcategory: [],
                  internalCode: [],
                  skuName: [],
                  storeFormat: [],
                  storeRegion: [],
                  storeCluster: [],
                  keyCharacteristicOne: [],
                  keyCharacteristicTwo: [],
                  ctm: [],
                  kvi: [],
              };
          });
  }

  fetchSelectionData(data: any) {
      if (!this.selectedCompetitorValue) return;

      const competitorValue = this.selectedCompetitorValue;

      this.isSelectionDataLoading = true;

      this.httpFetchCompetitorsSelectionData(data)
          .then((res) => {
              const tasks: ICompetitorSelectionTask[] = res.data;

              this.setCompetitorState(competitorValue);

              const state = this.competitorSelectionStates[competitorValue];

              tasks.forEach((task: ICompetitorSelectionTask) => {
                  state.tasksMap.set(task.productLinkId, task);
              });

              this.calculateSelectionProgress(competitorValue);

              const allCompleted = this.checkAllSelectionsCompletion(competitorValue);

              if (allCompleted) {
                  this.stopSelectionPolling(competitorValue);
                  Vue.set(state, 'isRunning', false);

                  this.fetchCompetitorLinkedProducts(null, false);
              }
          }).catch(() => {
              this.showError(this.$t('priceMonitoring.parsingProducts.errorSelectionStatus') as string);
          }).finally(() => {
              this.isSelectionDataLoading = false;
              this.isCompetitorLinkedProductsTableLoading = false;
          });
  }

  calculateSelectionProgress(competitorValue: string) {
      this.setCompetitorState(competitorValue);

      const state = this.competitorSelectionStates[competitorValue];
      const tasksMap = state.tasksMap;

      if (!tasksMap || tasksMap.size === 0) {
          Vue.set(state, 'progress', 0);

          return;
      }

      const completedTasks = Array.from(tasksMap.values()).filter(task => task.taskStatus === 'COMPLETED' || task.taskStatus === 'ERROR').length;

      Vue.set(state, 'progress', Math.round((completedTasks / tasksMap.size) * 100));
  }

  checkAllSelectionsCompletion(competitorValue: string): boolean {
      this.setCompetitorState(competitorValue);
      const state = this.competitorSelectionStates[competitorValue];
      const tasksMap = state.tasksMap;

      if (!tasksMap || tasksMap.size === 0) {
          return false;
      }

      return Array.from(tasksMap.values()).every(task => task.taskStatus === 'COMPLETED' || task.taskStatus === 'ERROR');
  }

  startSelectionPolling(competitorValue: string) {
      this.stopSelectionPolling(competitorValue);
      this.setCompetitorState(competitorValue);

      const intervalId = window.setInterval(() => {
          if (this.selectedCompetitorValue === competitorValue && this.competitorProductsTableData.length > 0) {
              this.fetchSelectionData(this.competitorProductsTableData.map(el => el.id));
          }
      }, 4000);

      Vue.set(this.competitorSelectionStates[competitorValue], 'pollingInterval', intervalId);
  }

  stopSelectionPolling(competitorValue: string) {
      this.setCompetitorState(competitorValue);

      const state = this.competitorSelectionStates[competitorValue];

      if (state.pollingInterval !== null) {
          clearInterval(state.pollingInterval);
          Vue.set(state, 'pollingInterval', null);
      }
  }

  stopAllSelectionPolling() {
      Object.keys(this.competitorSelectionStates).forEach((competitorValue) => {
          const state = this.competitorSelectionStates[competitorValue];

          if (state.pollingInterval !== null) {
              clearInterval(state.pollingInterval);
              Vue.set(state, 'pollingInterval', null);
          }
      });
  }

  getProductSelectionStatus(productId: number): 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'ERROR' | null {
      const task = this.selectionTasksMap.get(productId);
      return task ? task.taskStatus : null;
  }

  isProductSelectionInProgress(productId: number): boolean {
      return ['PENDING', 'IN_PROGRESS'].includes(this.getProductSelectionStatus(productId) || '');
  }

  isProductSelectionCompleted(productId: number): boolean {
      return this.getProductSelectionStatus(productId) === 'COMPLETED';
  }

  isProductSelectionErrored(productId: number): boolean {
      return this.getProductSelectionStatus(productId) === 'ERROR';
  }

  hasProductSearchResults(product: ICompetitorProduct): boolean {
      return (product.productSearchResults && product.productSearchResults.length > 0);
  }

  openProductSelectionModal(product: ICompetitorProduct) {
      this.selectedProductForModal = product;

      this.selectedCompetitorProductUrl = product.productSearchResults && product.productSearchResults.length > 0
          ? product.productSearchResults[0].link
          : '';

      this.isProductSelectionModalVisible = true;
  }

  closeProductSelectionModal() {
      this.isProductSelectionModalVisible = false;
      this.selectedProductForModal = null;
      this.selectedCompetitorProductUrl = '';
  }

  applySelectedCompetitorProduct() {
      if (this.selectedProductForModal && this.selectedCompetitorProductUrl) {
          this.$set(this.editingUrls, this.selectedProductForModal.id, this.selectedCompetitorProductUrl);
          this.closeProductSelectionModal();
      }
  }

  isPriceCategoryRecommends(sku: Sku): boolean {
    return sku.priceCategoryRecommendation;
  }

  isCartGeneratorRecommends(sku: Sku): boolean {
    return sku.cartGeneratorRecommendation;
  }

  isSelectedKvi(sku: Sku): boolean {
    return sku.kvi === 1;
  }

  setSelectedKvi(sku: Sku, selected: boolean) {
    if (selected) {
      if (sku.kvi !== 1) {
        this.productCodesForAddKvi.push(sku.internalCode);
      }
      const index = this.productCodesForDeleteKvi.findIndex((item) => {
        return item === sku.internalCode;
      });
      if (index !== -1) {
        this.productCodesForDeleteKvi.splice(index, 1);
      }
    } else {
      if (sku.kvi === 1) {
        this.productCodesForDeleteKvi.push(sku.internalCode);
      }
      const index = this.productCodesForAddKvi.findIndex((item) => {
        return item === sku.internalCode;
      });
      if (index !== -1) {
        this.productCodesForAddKvi.splice(index, 1);
      }
    }
  }

  getProductRange(productLine: string): string {
    const index = this.productLineOptions.findIndex((item) => {
      return item.value === productLine;
    });

    if (index !== -1) {
      return this.productLineOptions[index].value;
    } else {
      return "";
    }
  }

  inputOrDeleteProductRange(row: Sku, value: string) {
    const index = this.productRangesArray.findIndex((item) => {
      return item.internalCode === row.internalCode;
    });

    const rangeAndCode: InternalCodeAndProductRange = {
      internalCode: row.internalCode,
      productRange: value,
    };

    if (index === -1) {
      this.productRangesArray.push(rangeAndCode);
    } else {
      this.productRangesArray.splice(index, 1);
      this.productRangesArray.push(rangeAndCode);
    }
  }

  clearFilters() {
    this.sortBySKU = -1;
    this.selectKVI = this.defaultFilterValue.value;
    this.selectKVIRecommends = this.defaultFilterValue.value;
    this.selectCTM = { value: "all", label: this.$t('shared.selectBox.all') as string }.value;
    this.selectSegmentPrice = [];
    this.selectProductSegmentIdAndName = [];
    this.selectKeyCharacteristicOne = [];
    this.selectKeyCharacteristicTwo = [];
    this.selectRecipeAttributes = [];
    this.selectTreatmentAttributes = [];
    this.selectProductLine = { value: "all", label: this.$t('shared.selectBox.all') as string }.value;
    this.selectFilterProductGroup = this.defaultFilterValue.value;
    this.selectFilterProductCategory = this.defaultFilterValue.value;
    this.selectFilterProductSubcategory = this.defaultFilterValue.value;
    this.refreshSkuList();
  }

  toRow(competitor: RegularCompetitorsPricesView): CompetitorsPriceRow {
    const delta = this.computedDelta({
      lastPrice: competitor.lastPrice,
      competitorPrice: competitor.competitorPrice,
    });
    return {
      ...competitor,
      competitorDate: new Date(competitor.priceDate),
      ctm: competitor.ctm == null ? this.$t('shared.boolFilter.no') as string : competitor.ctm,
      delta,
    };
  }

  setSelectAll(
    exclude:
      | "SkuName"
      | "CompetitorsName"
      | "CompetitorPriority"
      | "Delta"
      | "LastPrice"
      | "CompetitorPrices"
      | "Kxt1"
      | "Kxt2"
      | "MonitorDates"
      | null
  ): void {
    exclude != "SkuName" && this.setSelectSkuName(this.viewCompetitors);
    exclude != "CompetitorsName" &&
      this.setSelectCompetitorsName(this.viewCompetitors);
    exclude != "CompetitorPriority" &&
      this.setSelectCompetitorsPriority(this.viewCompetitors);
    exclude != "LastPrice" && this.setSelectLastPrice(this.viewCompetitors);
    exclude != "CompetitorPrices" &&
      this.setSelectCompetitorsPrice(this.viewCompetitors);
    exclude != "Delta" && this.setSelectDelta(this.viewCompetitors);
    exclude != "MonitorDates" &&
      this.setSelectMonitorDate(this.viewCompetitors);
    exclude != "Kxt1" && this.setSelectCompetitorsKxtOne(this.viewCompetitors);
    exclude != "Kxt2" && this.setSelectCompetitorsKxtTwo(this.viewCompetitors);
  }

  setSelectSkuName(response: CompetitorsPriceRow[]) {
    const skuNameOptions = response
      .map((value) => value.skuName)
      .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()));
    this.skuNameFilterOptions = Array.from(new Set(skuNameOptions)).map(
      (option) => ({
        value: option,
        label: option,
      })
    );
  }

  setSelectCompetitorsName(response: CompetitorsPriceRow[]) {
    const competitorsNameOptions = response
      .map((value) => value.competitorName)
      .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()));
    this.competitorsNameFilterOptions = Array.from(
      new Set(competitorsNameOptions)
    ).map((option) => ({
      value: option,
      label: option,
    }));
  }

  setSelectCompetitorsPriority(response: CompetitorsPriceRow[]) {
    const competitorsPriorityOptions = response
      .map((value) => value.competitorPriority)
      .sort(compareNumber);
    this.competitorsPriorityFilterOptions = Array.from(
      new Set(competitorsPriorityOptions)
    ).map((option) => ({
      value: option ? option.toString() : "",
      label: option ? option.toString() : "",
    }));
  }

  setSelectLastPrice(response: CompetitorsPriceRow[]) {
    const lastPriceOptions = response
      .map((value) => value.lastPrice)
      .sort(compareNumber);
    this.lastPriceFilterOptions = Array.from(new Set(lastPriceOptions)).map(
      (option) => ({
        value: option ? option.toString() : "",
        label: option ? option.toString() : "",
      })
    );
  }

  setSelectCompetitorsPrice(response: CompetitorsPriceRow[]) {
    const competitorsPriceOptions = response
      .map((value) => value.competitorPrice)
      .sort(compareNumber);
    this.competitorsPriceFilterOptions = Array.from(
      new Set(competitorsPriceOptions)
    ).map((option) => ({
      value: option ? option.toString() : "",
      label: option ? option.toString() : "",
    }));
  }

  setSelectDelta(response: CompetitorsPriceRow[]) {
    const deltaOptions = response
      .map((value) => this.computedDelta(value))
      .sort(compareNumber)
      .map((delta) => (delta ? delta.toFixed(2) : "0"));
    this.deltaFilterOptions = Array.from(new Set(deltaOptions)).map(
      (deltaOption) => ({
        value: deltaOption,
        label: deltaOption,
      })
    );
  }

  setSelectCompetitorsKxtOne(response: CompetitorsPriceRow[]) {
    const competitorsKxtOneOptions = response
      .map((value) => value.keyCharacteristicOfTheProductIsOne)
      .filter((it) => it !== null)
      .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()));
    this.keyCharacteristicOneForCompetitorsOptions = Array.from(
      new Set(competitorsKxtOneOptions)
    ).map((option) => ({
      value: option,
      label: option,
    }));
  }

  setSelectCompetitorsKxtTwo(response: CompetitorsPriceRow[]) {
    const competitorsKxtTwoOptions = response
      .map((value) => value.keyCharacteristicOfTheProductIsTwo)
      .filter((it) => it !== null)
      .sort((a, b) => a.toUpperCase().localeCompare(b.toUpperCase()));
    this.keyCharacteristicTwoForCompetitorsOptions = Array.from(
      new Set(competitorsKxtTwoOptions)
    ).map((option) => ({
      value: option,
      label: option,
    }));
  }

  setSelectMonitorDate(response: CompetitorsPriceRow[]) {
    const formattedDates = response
      .map((value) => new Date(value.competitorDate))
      .sort((a: Date, b: Date) => a.getTime() - b.getTime())
      .map((value) => value.toLocaleDateString());
    this.monitoringDateFilterOptions = Array.from(new Set(formattedDates)).map(
      (formattedDate) => ({
        value: formattedDate,
        label: formattedDate,
      })
    );
  }

  computedDelta = (item: {
    lastPrice: number;
    competitorPrice: number;
  }): number => {
    return (item.lastPrice / item.competitorPrice - 1) * 100;
  };

  onMultiSelectToggle(open: boolean) {
    this.dropDownOpen = open;
    if (!open) {
      if (this.onDropdownClosed != null) {
        this.onDropdownClosed.apply(open);
        this.onDropdownClosed = null;
      }
    }
  }

  setCalcIndividConfig(
    config: ConfigMap<IndividualConfig>,
    sku: string,
    property: keyof IndividualConfig,
    value: number | SelectBox<any> | string
  ) {
    if (!(sku in config)) {
      config[sku] = {};
    }
    if (typeof value === "number" && Number.isNaN(value)) {
      config[sku][property] = null;
    } else {
      config[sku][property] = value;
    }
  }

  calculateOnlyLastPricesInSkuInPanel() {
    this.needCalculateSkuLastPricesOnly = true;
    this.refreshSkuTableInPanel();
    this.calcSkuLastPricesButtonDisabled = true;
  }

  calculateOnlyActualProfitInSkuInPanel() {
    this.needCalculateSkuActualProfitabilityOnly = true;
    this.refreshSkuTableInPanel();
    this.calcSkuActualProfitButtonDisabled = true;
  }

  private refreshSkuList() {
    const oldRefreshId = this.refreshSkuListId;
    if (oldRefreshId !== -1) {
      clearTimeout(oldRefreshId);
    }
    const timeoutId = setTimeout(() => {
      if (this.refreshSkuListId === timeoutId) {
        this.skuListCurrentPage = 1;
        const skuTableRef = this.$refs.skuTableRef as any;
        if (typeof skuTableRef !== "undefined") {
          skuTableRef.$forceUpdate();
        }
        this.refreshSkuListId = -1;
      }
    }, 250);
    this.refreshSkuListId = timeoutId;
    this.isFiltersChanged = 1;
  }

  private refreshSkuTableInPanel() {
    const oldRefreshId = this.refreshTabPanelSkuListId;
    if (oldRefreshId !== -1) {
      clearTimeout(oldRefreshId);
    }
    const timeoutId = setTimeout(() => {
      if (this.refreshTabPanelSkuListId === timeoutId) {
        this.pagination.current = 1;
        const skuTableInPanel = this.$refs.skuTableInPanel as any;
        if (typeof skuTableInPanel !== "undefined") {
          skuTableInPanel.$forceUpdate();
        }
        this.refreshTabPanelSkuListId = -1;
      }
    }, 250);
    this.refreshTabPanelSkuListId = timeoutId;
    this.isFiltersChanged = 1;
  }

  private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
    const [
      selectRegions,
      selectGroups,
      selectCategories,
      selectSubcategories,
      selectSegments,
    ] = this.selectData();
    return {
      type: taskType,
      tradingId: this.$kviCart.selectMarket.id,
      storeFormat:
        this.$kviCart.formatSelected == null ||
        this.$kviCart.formatSelected <= 0
          ? null
          : [this.$kviCart.formatSelected],
      storeCluster:
        this.$kviCart.clusterSelected == null
          ? null
          : this.$kviCart.clusterSelected,
      groups: selectGroups,
      categories: selectCategories,
      subcategories: selectSubcategories,
      subcategory:
        this.$kviCart.subcategory == null || this.$kviCart.subcategory <= 0
          ? null
          : [this.$kviCart.subcategory],
      productSegments: selectSegments,
      storeRegion: selectRegions,
      byReports: false,
    };
  }

  private getKviRecommendsTaskInfo(
    filterType: TaskInfoFilterType
  ): GetTaskInfo {
    const [, selectRegions, , selectFormats] = this.kviRecommendsSelectData();
    return {
      type: filterType,
      tradingId: this.$packageKviRecommends.selectMarket.id,
      categories: LocalData.filterNumberArrays(
        this.$packageKviRecommends.categoriesOfProduct
      ),
      groups: LocalData.filterNumberArrays(
        this.$packageKviRecommends.groupsOfProduct
      ),
      subcategory: LocalData.filterNumberArrays(
        this.$packageKviRecommends.subcategories,
        true
      ),
      segments: null,
      storeFormat: selectFormats,
      storeCluster: this.$packageKviRecommends.clusterSelected,
      storeRegion: selectRegions,
      byReports: false,
    };
  }

  private getFullCommonFilter(): KviShoppingCartFilters {
    const [
      selectRegions,
      selectGroups,
      selectCategories,
      selectSubcategories,
      selectSegments,
    ] = this.selectData();
    const allCheck = this.$kviCart.allCheck;
    const discountPrice = this.$kviCart.discountPrice;
    const pennies = this.$kviCart.pennies;
    const countAtLastPurchasePrice = this.$kviCart.countAtLastPurchasePrice;
    const countAtFuturePurchasePrice = this.$kviCart.countAtFuturePurchasePrice;
    const allNewPricesWithoutPennies = this.$kviCart.allNewPricesWithoutPennies;
    const allClaster = this.$kviCart.allClaster;
    const xyzChecked = this.$kviCart.xyzChecked;
    const uvwChecked = this.$kviCart.uvwChecked;
    const individualConfigsObj = Object.create(null);
    // tslint:disable-next-line: forin
    for (const key in this.$kviCart.individualCommonParams) {
      const value = this.$kviCart.individualCommonParams[key];
      if (typeof value !== "undefined" && value !== null) {
        individualConfigsObj[key] = this.prepareIndividualConfig(value);
      }
    }
    return {
      allCheck,
      discountPrise: discountPrice,
      pennies,
      countAtLastPurchasePrice,
      countAtFuturePurchasePrice,
      allNewPricesWithoutPennies,
      xyzChecked,
      uvwChecked,
      allClaster,
      coefficientK1: this.$kviCart.selectCoefficent.value.k1,
      coefficientK2: this.$kviCart.selectCoefficent.value.k2,
      category: null,
      storeCluster: this.$kviCart.clusterSelected,
      seasonValues: [],
      buyerSegments: [],
      spreadUVWParams: this.$kviCart.uvwParams,
      spreadXYZParams: this.$kviCart.xyzParams,
      storeRegionValues: selectRegions,
      groupsOfProduct: selectGroups,
      categories: selectCategories,
      subcategories: selectSubcategories,
      productSegments: selectSegments,
      newProductLifespanInDays: this.$kviCart.newProductLifespanInDays,
      storeFormat: this.$kviCart.formatSelected,
      tradingId: this.$kviCart.selectMarket.id,
      calculationDepth: +this.$kviCart.calculationDepth,
      correlation: this.$kviCart.correlation ? this.$kviCart.correlation : 0.7,
      highElasticity: this.$kviCart.highElasticity
        ? this.$kviCart.highElasticity
        : -0.5,
      intervalOfUltimateElasticity: this.$kviCart.intervalOfUltimateElasticity,
      competitorsPricesParams: this.$kviCart.competitorsPrices,
      kviStrategy: this.$kviCart.kviStrategy.value,
      percentageOfCompetitorsPrice: this.$kviCart.percentageOfCompetitorsPrice,
      marginalProfitability: this.$kviCart.marginalProfitability,
      marginalProfit: this.$kviCart.marginalProfit,
      maxMarginalProfit: this.$kviCart.maxMarginalProfit != null ? this.$kviCart.maxMarginalProfit : 100,
      marginalPriceDifference: this.$kviCart.marginalPriceDifference,
      calculationDay: +this.$kviCart.calculationDay,
      priceCorridor: this.$kviCart.priceCorridor,
      changePriceCorridor: this.$kviCart.changePriceCorridor,
      priceIncreaseLimit: this.$kviCart.priceIncreaseLimit,
      fixLowerBorder: this.$kviCart.fixLowerBorder,
      individualCommonParams: individualConfigsObj,
      depthToPurchasePrice: this.$kviCart.depthToPurchasePrice,
      priceFamilies: this.$kviCart.priceFamilies,
      hardPriceFamilies: this.$kviCart.hardPriceFamilies,
      groupOfProduct: this.$kviCart.groupOfProduct,
      // tslint:disable-next-line: no-non-null-assertion
      priceOpt: this.$kviCart.selectCoefficent.value.enum!,
      byPromoPrices: this.$kviCart.byPromoPrices,
      useCompetitorsPrices: this.$kviCart.useCompetitorsPrices,
      competitorsPricePeriod: this.$kviCart.competitorsPricePeriod,
      competitorsCodes: this.$kviCart.competitorsCodes,
      competitorsPriceMethod: this.$kviCart.competitorsPriceMethod.value,
      competitorsPriceAdjustment: this.$kviCart.competitorsPriceAdjustment,
      competitorsInfluencesCoef: this.$kviCart.competitorsInfluencesCoef,
      competitorsMinimumProfit: this.$kviCart.competitorsMinimumProfit,
      competitorsMaximumProfit: this.$kviCart.competitorsMaximumProfit != null ? this.$kviCart.competitorsMaximumProfit : 100,
      competitorsControlParam: this.$kviCart.competitorsControlParam,
      competitorsPriceStrategy: this.$kviCart.competitorsPriceStrategy.value,
      roundKviCompetitorPrice: this.$kviCart.roundKviCompetitorPrice,
      calculateByRegression: !this.$kviCart.calculateByElasticity,
      recalculateCtm: this.$kviCart.recalculateCtm,
      priceChangeLimit: this.$kviCart.priceChangeLimit,
      priceChangeLimitKvi: this.$kviCart.priceChangeLimitKvi,
      priceChangeLimitComp: this.$kviCart.priceChangeLimitComp,
      useBrutForcingParams: false,
      saveAfterOptimize: false,
      optimizationDiff: -1,
      calculatePYR: this.$kviCart.calculatePYR,
      periodPriceIncreaseLimit: this.$kviCart.periodPriceIncreaseLimit,
      period: this.$kviCart.period.value,
      decreaseSalesCount: this.$kviCart.decreaseSalesCount,
      newProductPriceStrategy: this.$kviCart.newProductPriceStrategy.value,
      priceGap: this.$kviCart.priceGap,
      priceGapCtmPc: this.$kviCart.priceGapCtmPc,
      findAutomaticallyPriceSegments: false,
      countPriceSegments: -1,
      promoCalc: false,
      percentageOfRecommendsKviCount: this.$kviCart
        .percentageOfRecommendsKviCount,
      saveKviSign: this.$kviCart.saveKviSign,
      useSegmentsPriceInSearchKVIRecParam: this.$kviCart
        .useSegmentsPriceInSearchKVIRecParam,
      categoryStrategy: this.$kviCart.categoryStrategy.value,
      useCompetitorsForKviRecommends: this.$kviCart
        .useCompetitorsForKviRecommends,
      competitorsPeriodForKviRecommends: this.$kviCart
        .competitorsPeriodForKviRecommends,
      productCodesForAddKvi: this.productCodesForAddKvi,
      productCodesForDeleteKvi: this.productCodesForDeleteKvi,
      productCodesForAddCtmPurpose: this.productCodesForAddCtmPurpose,
      productCodesForDeleteCtmPurpose: this.productCodesForAddCtmPurpose,
      roundPricesWithEqualCompStrategy: this.$kviCart
        .roundPricesWithEqualCompStrategy,
      calculateCompAllowedDeviation: this.$kviCart
        .calculateCompAllowedDeviation,
      useCompElasticity: this.$kviCart.useCompElasticity,
      minProfitKVI: this.$kviCart.minProfitKVI,
      maxProfitKVI: this.$kviCart.maxProfitKVI != null ? this.$kviCart.maxProfitKVI : 100,
      productRangesAndInternalCodes: this.productRangesArray,
      randomPennies: this.$kviCart.randomPennies,
      manualPennies: this.$kviCart.manualPennies,
      calcWithBatchNumber: true,
      competitorPriceControlParameterPc: this.$kviCart
        .competitorPriceControlParameterPc,
      thompsonSampling: this.$kviCart.thompsonSampling,
      percentileType: this.$kviCart.percentileType.value,
      revaluationCalculateParams: this.$kviCart.revaluationCalculateParams,
      isFixPricePromo: this.$kviCart.isFixPricePromo,
      spreadByPriceSegments: this.$calc.spreadByPriceSegments,
      kviCartIdFilter: this.$kviCart.selectKviCart.id,
    };
  }

  private getKviCartFilter(): KviCartFilters {
    const [selectRegions] = this.selectData();
    const revaluationCalculateParams = {
      revaluationNumber: this.$kviCart.revaluationCalculateParams
        .revaluationNumber,
      revaluationFrequencyCalculationDepth: this.$kviCart
        .revaluationCalculateParams.revaluationFrequencyCalculationDepth,
      purchasePriceDelta: this.$kviCart.revaluationCalculateParams
        .purchasePriceDelta,
      competitorsPriceDelta: this.$kviCart.revaluationCalculateParams
        .competitorsPriceDelta,
      calculateByAllCompetitors: this.$kviCart.revaluationCalculateParams
        .calculateByAllCompetitors,
      useRevaluationCalculate: this.$kviCart.revaluationCalculateParams
        .useRevaluationCalculate,
    };
    const individualConfigsObj = Object.create(null);
    // tslint:disable-next-line: forin
    for (const key in this.$kviCart.individualCommonParams) {
      const value = this.$kviCart.individualCommonParams[key];
      if (typeof value !== "undefined" && value !== null) {
        individualConfigsObj[key] = this.prepareIndividualConfig(value);
      }
    }
    return {
      kviCartId: this.$kviCart.selectKviCart.id,
      tradingId: this.$kviCart.selectMarket.id,
      storeFormat: this.$kviCart.formatSelected,
      groupOfProduct: null,
      category: null,
      subcategory: null,
      segment: null,
      storeRegionValues: selectRegions,
      groupsOfProduct: null,
      categories: null,
      subcategories: null,
      productSegments: null,
      byPromoPrices: this.$kviCart.byPromoPrices,
      downloadParamsWithCategory: this.$kviCart.downloadParamsWithCategory,
      storeCluster: this.$kviCart.clusterSelected,
      separateClusters: this.$kviCart.separateClusters,
      coefficientK1: this.$kviCart.selectCoefficent.value.k1,
      coefficientK2: this.$kviCart.selectCoefficent.value.k2,
      marginalProfit: this.$kviCart.marginalProfit,
      maxMarginalProfit: this.$kviCart.maxMarginalProfit != null ? this.$kviCart.maxMarginalProfit : 100,
      priceIncreaseLimit: this.$kviCart.priceIncreaseLimit,
      fixLowerBorder: this.$kviCart.fixLowerBorder,
      priceChangeLimit: this.$kviCart.priceChangeLimit,
      priceChangeLimitKvi: this.$kviCart.priceChangeLimitKvi,
      priceChangeLimitComp: this.$kviCart.priceChangeLimitComp,
      periodPriceIncreaseLimit: this.$kviCart.periodPriceIncreaseLimit,
      period: this.$kviCart.period.value,
      competitorsPricesParams: this.$kviCart.competitorsPrices,
      percentageOfCompetitorsPrice: this.$kviCart.percentageOfCompetitorsPrice,
      kviStrategy: this.$kviCart.kviStrategy.value,
      minProfitKVI: this.$kviCart.minProfitKVI,
      maxProfitKVI: this.$kviCart.maxProfitKVI != null ? this.$kviCart.maxProfitKVI : 100,
      roundKviCompetitorPrice: this.$kviCart.roundKviCompetitorPrice,
      percentageOfRecommendsKviCount: this.$kviCart
        .percentageOfRecommendsKviCount,
      useSegmentsPriceInSearchKVIRecParam: this.$kviCart
        .useSegmentsPriceInSearchKVIRecParam,
      saveKviSign: this.$kviCart.saveKviSign,
      useCompetitorsForKviRecommends: this.$kviCart
        .useCompetitorsForKviRecommends,
      competitorsPeriodForKviRecommends: this.$kviCart
        .competitorsPeriodForKviRecommends,
      useCompetitorsPrices: this.$kviCart.useCompetitorsPrices,
      useCompElasticity: this.$kviCart.useCompElasticity,
      calculateCompAllowedDeviation: this.$kviCart
        .calculateCompAllowedDeviation,
      competitorsPriceMethod: this.$kviCart.competitorsPriceMethod.value,
      competitorsPriceAdjustment: this.$kviCart.competitorsPriceAdjustment,
      competitorsControlParam: this.$kviCart.competitorsControlParam,
      competitorsPriceStrategy: this.$kviCart.competitorsPriceStrategy.value,
      roundPricesWithEqualCompStrategy: this.$kviCart
        .roundPricesWithEqualCompStrategy,
      competitorsPricePeriod: this.$kviCart.competitorsPricePeriod,
      competitorsInfluencesCoef: this.$kviCart.competitorsInfluencesCoef,
      competitorsMinimumProfit: this.$kviCart.competitorsMinimumProfit,
      competitorsMaximumProfit: this.$kviCart.competitorsMaximumProfit != null ? this.$kviCart.competitorsMaximumProfit : 100,
      competitorsCodes: this.$kviCart.competitorsCodes,
      productCodesForAddKvi: this.productCodesForAddKvi,
      productCodesForDeleteKvi: this.productCodesForDeleteKvi,
      productCodesForAddCtmPurpose: this.productCodesForAddCtmPurpose,
      productCodesForDeleteCtmPurpose: this.productCodesForDeleteKvi,
      productRangesAndInternalCodes: this.productRangesArray,
      // tslint:disable-next-line: no-non-null-assertion
      priceOpt: this.$kviCart.selectCoefficent.value.enum!,
      // tslint:disable-next-line: no-non-null-assertion
      individualCommonParams: individualConfigsObj,
      kviCartChangePrices: this.$kviCart.kviCartChangePrices.value,
      competitorPriceControlParameterPc: this.$kviCart
        .competitorPriceControlParameterPc,
      revaluationCalculateParams: revaluationCalculateParams,
      checkMarginDeclineProfit: this.$kviCart.checkMarginDeclineProfit,
      declineProfitabilityPc: this.$kviCart.declineProfitabilityPc,
      searchPreviousPricesDepth: this.$kviCart.searchPreviousPricesDepth,
      thompsonSampling: this.$kviCart.thompsonSampling,
      percentileType: this.$kviCart.percentileType.value,
      isFixPricePromo: this.$kviCart.isFixPricePromo,
    };
  }

  private getPackageCalcConfig(): KviCartPackageConfig {
    const [selectRegions] = this.selectData();
    const paramFilters = this.getKviCartFilter();
    return {
      kviCartChangePrices: this.$kviCart.kviCartChangePrices.value,
      kviCartId: this.$kviCart.selectKviCart.id,
      kviCartsParams: paramFilters,
      coefficientK1: this.$kviCart.selectCoefficent.value.k1,
      coefficientK2: this.$kviCart.selectCoefficent.value.k2,
      // tslint:disable-next-line: no-non-null-assertion
      categories: null,
      subcategories: null,
      productSegments: null,
      storeCluster:
        this.$kviCart.clusterSelected == null
          ? []
          : this.$kviCart.clusterSelected,
      storeRegionValues: selectRegions,
      groupsOfProduct: null,
      applyOmnichannel: false,
      sendGeneralReportNotification:
        localStorage.getItem("sendGeneratedReportNotification") === "true",
      isFixPricePromo: this.$kviCart.isFixPricePromo,
      storeFormat:
        this.$kviCart.formatSelected == null ||
        this.$kviCart.formatSelected <= 0
          ? []
          : [this.$kviCart.formatSelected],
      tradingId: this.$kviCart.selectMarket.id,
      // tslint:disable-next-line: no-non-null-assertion
      priceOpt: this.$kviCart.selectCoefficent.value.enum!,
      separateSubcategories: true,
      separateClusters: this.$kviCart.separateClusters,
      manualPennies: this.$kviCart.manualPennies,
      percentileType: this.$kviCart.percentileType.value,
      calcWithBatchNumber: true,
      thompsonSampling: false,
      useSkuRotation: false,
      useFixedPrices: true,
    };
  }

  private getSkuModalFilter(): SkuFilter {
        return {
            needCalculateSku: false,
            groupOfProduct: null,
            groupsOfProduct: this.modalLevelFiltersSelected.groups.filter((value: number) => value !== -1),
            category: null,
            categories: this.modalLevelFiltersSelected.categories.filter((value: number) => value !== -1),
            subcategories: this.modalLevelFiltersSelected.subcategories.filter((value: number) => value !== -1),
            storeFormat: this.competitorSelected.format ? this.competitorSelected.format.id : null,
            storeFormats: [],
            storeRegionValues: this.competitorSelected.region ? [this.competitorSelected.region.id] : [],
            storeCluster: this.competitorSelected.cluster ? this.competitorSelected.cluster.id : null,
            storeClusters: [],
            seasonValues: [],
            buyerSegments: [],
            tradingId: this.currentTradingId,
            calculationDepth: this.$calc.calculationDepth,
            calculationDay: this.$calc.calculationDay,
            skuFilter: this.skuFilterModal,
            discountPrise: false,
            promo: false,
            sortBySKU: this.sortBySKU,
            kvi: this.selectKVI,
            ctm: null,
            productSegments: [],
        };
    }

  private getSkuFilter(): KviCartsSkuFilter {
    const [
      selectRegions,
      selectGroups,
      selectCategories,
      selectSubcategories,
      selectSegments,
    ] = this.selectData();

    return {
      storeCluster: this.$kviCart.clusterSelected,
      groupsOfProduct: selectGroups,
      categories: selectCategories,
      subcategories: selectSubcategories,
      productSegments: selectSegments,
      seasonValues: [],
      buyerSegments: [],
      storeRegionValues: selectRegions,
      storeFormat: this.$kviCart.formatSelected,
      tradingId: this.$kviCart.selectMarket.id,
      calculationDepth: this.$kviCart.calculationDepth,
      calculationDay: this.$kviCart.calculationDay,
      skuFilter: this.skuFilter,
      groupOfProduct: this.$kviCart.groupOfProduct,
      category: this.$kviCart.categoryOfProduct,
      discountPrise: false,
      promo: false,
      sortBySKU: this.sortBySKU,
      kvi: this.selectKVI,
      ctm: this.selectCTM,
      priceSegments: this.selectSegmentPrice,
      needCalculateSku: this.skuListWithCalculating,
      needCalculateSkuLastPricesOnly: this.needCalculateSkuLastPricesOnly,
      needCalculateSkuActualProfitabilityOnly: this
        .needCalculateSkuActualProfitabilityOnly,
      kviRecommendation: this.selectKVIRecommends,
      keyCharacteristicOfTheProductIsOne: this.selectKeyCharacteristicOne,
      keyCharacteristicOfTheProductIsTwo: this.selectKeyCharacteristicTwo,
      recipeAttributes: this.selectRecipeAttributes,
      treatmentAttributes: this.selectTreatmentAttributes,
      alwaysCalculateProductSegments: true,
      productRangeFilter: this.selectProductLine,
      groupFilterInSkuList:
        this.$kviCart.groupOfProduct || this.selectFilterProductGroup,
      categoryFilterInSkuList:
        this.$kviCart.categoryOfProduct || this.selectFilterProductCategory,
      subcategoryFilterInSkuList:
        this.$kviCart.subcategory || this.selectFilterProductSubcategory,
      segmentFilterInSkuList:
        this.$kviCart.segment || this.selectFilterProductSegment,
      competitorsPricePeriod: this.$kviCart.competitorsPricePeriod,
      kviCartIdFilter: this.$kviCart.selectKviCart.id,
      sortingField: null,
      isKviCartCompetitorsGrid: false,
    };
  }

  private getCompetitorsFilter(): CompetitorsPriceFilter {
    const [
      selectRegions,
      selectGroups,
      selectCategories,
      selectSubcategories,
      selectSegments,
    ] = this.selectData();
    return {
      discountPrise: this.$kviCart.discountPrice,
      storeCluster: this.$kviCart.clusterSelected,
      groupsOfProduct: selectGroups,
      categories: selectCategories,
      subcategories: selectSubcategories,
      productSegments: selectSegments,
      seasonValues: [],
      buyerSegments: [],
      storeRegionValues: selectRegions,
      storeFormat: this.$kviCart.formatSelected,
      tradingId: this.$kviCart.selectMarket.id,
      calculationDepth: +this.$kviCart.calculationDepth,
      calculationDay: +this.$kviCart.calculationDay,
      skuFilter: this.skuFilter,
      groupOfProduct: this.$kviCart.groupOfProduct,
      category: this.$kviCart.categoryOfProduct,
      competitorsPricePeriod: this.$kviCart.competitorsPricePeriod,
      promo: false,
      internalCodes: this.cartInternalCodes,
      sortingField: this.sortingField,
      isKviCartCompetitorsGrid: true,
    };
  }

  get paramsSum(): boolean {
    const u = this.$kviCart.uvwParams.u;
    const v = this.$kviCart.uvwParams.v;
    const w = this.$kviCart.uvwParams.w;
    if (
      u.toString().length === 0 ||
      v.toString().length === 0 ||
      w.toString().length === 0
    ) {
      return false;
    }
    const sum = +v + +u + +w;
    return sum === 100;
  }

  get paramsSumXYZ(): boolean {
    const x = this.$kviCart.xyzParams.x;
    const y = this.$kviCart.xyzParams.y;
    const z = this.$kviCart.xyzParams.z;
    if (
      x.toString().length === 0 ||
      y.toString().length === 0 ||
      z.toString().length === 0
    ) {
      return false;
    }
    const sum = x + y + z;
    return sum === 100;
  }

  get calculationDepthValidate(): boolean {
    return this.$kviCart.calculationDepth * 7 >= this.$kviCart.calculationDay;
  }

  get calculationDayValidate(): boolean {
    return this.$kviCart.calculationDay > 0;
  }

  get priceIncreaseLimitValidate(): boolean {
    const priceIncreaseLimit = this.$kviCart.priceIncreaseLimit;
    return priceIncreaseLimit.toString() !== "" && priceIncreaseLimit >= 0;
  }

  get competitorsPricesValidate(): boolean {
    const competitorsP = this.$kviCart.competitorsPrices.toString();
    const numberPattern = RegExp(/^[1-9][0-9]?$|^100$/);

    return numberPattern.test(competitorsP);
  }

  get competitorsMinProfitValidate(): boolean {
    const competitorsMinimumProfit = this.$kviCart.competitorsMinimumProfit;
    return competitorsMinimumProfit.toString() !== "";
  }

  get minProfitKVIValidate(): boolean {
    const minProfitKvi = this.$kviCart.minProfitKVI;
    return (
      minProfitKvi.toString() !== "" &&
      minProfitKvi >= -50 &&
      minProfitKvi <= 500
    );
  }

  get marginalProfitValidate(): boolean {
    const marginalProfit = this.$kviCart.marginalProfit;
    if (marginalProfit < 0) {
      this.marginalErrorText = this.$t('priceMonitoring.parsingProducts.marginalErrorText') as string;
    } else {
      this.marginalErrorText = "";
    }
    return marginalProfit.toString() !== "" && marginalProfit < 100;
  }

  get priceChangeLimitValidate(): boolean {
    const priceChangeLimit = this.$kviCart.priceChangeLimit;
    return (
      priceChangeLimit.toString() !== "" &&
      priceChangeLimit >= 0 &&
      priceChangeLimit < 100
    );
  }

  get periodPriceIncreaseLimitValidate(): boolean {
    const periodPriceIncreaseLimit = this.$kviCart.periodPriceIncreaseLimit;
    return (
      periodPriceIncreaseLimit.toString() !== "" &&
      periodPriceIncreaseLimit >= 0
    );
  }

  get highElasticityCheck(): boolean {
    const numberPattern = RegExp(/^[+-]?([0-9]+[.])?[0-9]+$/);
    const highElasticity = this.$kviCart.highElasticity.toString();
    this.$log.debug(
      highElasticity.length > 0,
      numberPattern.test(highElasticity)
    );
    return numberPattern.test(highElasticity);
  }

  get competitorPriceControlParameterPcValidate(): boolean {
    return (
      this.$kviCart.competitorPriceControlParameterPc.toString() !== "" &&
      this.$kviCart.competitorPriceControlParameterPc > 0 &&
      this.$kviCart.competitorPriceControlParameterPc <= 100
    );
  }

  get marginalProfitDeclinePcValidate(): boolean {
    const declineProfitabilityPc = this.$kviCart.declineProfitabilityPc;
    return declineProfitabilityPc != null && declineProfitabilityPc < 100;
  }

  linkSelectedProductsToCompetitor() {
      const obj = {
          tradingId: this.currentTradingId,
          competitorCode: this.competitorSelected.competitorCode,
          competitorName: this.competitorSelected.competitorName,
          storeFormatId: this.competitorSelected.format.id,
          storeRegionId: this.competitorSelected.region.id,
          storeClusterId: this.competitorSelected.cluster && this.competitorSelected.cluster.id ? this.competitorSelected.cluster.id : null,
          productLinkList: this.selectedProductsFromModal,
      };

        this.httpLinkProductsToCompetitor(obj)
            .then(() => {
                this.showInfo(this.$t('priceMonitoring.parsingProducts.successLinkProducts') as string);
                this.isLinkProductsModalVisible = false;

                this.selectedProductsFromModal = [];

                this.fetchCompetitorLinkedProducts();
                this.fetchCompetitorLinkedProductsTableOptions();
            })
            .catch((e) => {
                this.showError(this.$t('priceMonitoring.parsingProducts.errorLinkProducts') as string);
            })
    }

    private refreshSkuTableInModal() {
        const skuTableInModal = this.$refs.skuTableInModal as any;
        if (typeof skuTableInModal !== 'undefined') {
            skuTableInModal.$forceUpdate();
        }
    }

    onSearchModal(){
        this.fetchFullSkuList();
        this.refreshSkuTableInModal();
    }

    clearFilterModal() {
        this.skuFilterModal = '';
        this.fetchFullSkuList();
    }

    isSelectedCompetitorProduct(internalCode: string) {
        const index = this.selectedProductsFromModal.findIndex((item) => {
            return item.internalCode === internalCode;
        });
        return index !== -1;
    }

    setSelectedProducts(sku: Sku, selected: boolean) {
        const index = this.selectedProductsFromModal.findIndex((item) => {
            return item.internalCode === sku.internalCode && item.groupId === sku.productGroupId && item.categoryId === sku.categoryId;
        });

        if (selected) {
            if (index === -1) {
                const selectedProduct: IProductsToLinkToCompetitor = {
                    internalCode: sku.internalCode,
                    skuName: sku.skuName,
                    groupId: sku.productGroupId!,
                    categoryId: sku.categoryId!,
                    subcategoryId: sku.subcategoryId || null,
                    keyCharacteristicOne: sku.keyCharacteristicOfTheProductIsOne,
                    keyCharacteristicTwo: sku.keyCharacteristicOfTheProductIsTwo,
                    kvi: sku.kvi,
                };

                this.selectedProductsFromModal.push(selectedProduct);
            }
        } else {
            if (index !== -1) {
                this.selectedProductsFromModal.splice(index, 1);
            }
        }
    }

    getModalLevelFilterCompetitorValue(type: 'format' | 'region' | 'cluster'): null[] | number[] {
        return this.competitorSelected[type] && this.competitorSelected[type]!.id ? [this.competitorSelected[type]!.id] : [null];
    }

    getModalLevelFilterCompetitorOptions(type: 'format' | 'region' | 'cluster') {
        return this.competitorSelected[type] && this.competitorSelected[type]!.name && this.competitorSelected[type]!.id
            ? [{label: this.competitorSelected[type]!.name, value: this.competitorSelected[type]!.id}]
            : [{label: this.$t('shared.selectBox.all') as string, value: null}];
    }

    setSelectedSite(site?: string) {
        if (site && this.competitorSiteOptions.find(siteOption => siteOption.value === site)) {
            this.selectedSite = site;
        } else {
            this.selectedSite = null;
        }
    }

    filterCompetitorOption(input: string, option: any): boolean {
        const lowerInput = input.toLowerCase();

        const propsData = option.componentOptions && option.componentOptions.propsData;

        if (propsData) {
            const label = (propsData.label || '').toLowerCase();
            const value = (propsData.value || '').toLowerCase();

            return label.includes(lowerInput) || value.includes(lowerInput);
        }

        return false;
    }

    handleCompetitorChanged(value: string) {
        this.selectedCompetitorValue = value;

        const competitor = this.selectCompetitorOptions.find(el => el.value === value)

        if (competitor) {
            this.competitorSelected = JSON.parse(JSON.stringify({
                ...competitor,
                format: competitor.competitorFormat,
                region: competitor.competitorRegion,
                cluster: competitor.competitorCluster,
            }));

            this.setSelectedSite(competitor.lastParsingSearchSite);

            localStorage.setItem('compDirectorySelectedCompetitor', `code=${competitor.competitorCode};formatId=${competitor.competitorFormat.id};regionId=${competitor.competitorRegion.id};clusterId=${competitor.competitorCluster ? competitor.competitorCluster.id : ''};`)
        }

        this.linkedProductsTableFilterValues = {
            internalCodes: [],
            skuNames: [],
            categoryIds: [],
            subcategoryIds: [],
            groupIds: [],
            kviValue: -1,
            ctmValue: 'all',
        };

        this.skuListAddProductsToCartModal = [];

        this.resetIncludedAndExcludedCheckboxes();
        this.isCommonCheckboxSelected = false;

        this.fetchCompetitorLinkedProducts();
        this.fetchCompetitorLinkedProductsTableOptions();

        this.setCompetitorState(value);

        const newCompetitorState = this.competitorSelectionStates[value];

        if (newCompetitorState.isRunning && newCompetitorState.pollingInterval === null) {
            this.startSelectionPolling(value);
        }
    }

    fetchCompetitorLinkedProducts(currentPage?: number | null, needFetchSelectionData: boolean = true) {
        if (currentPage) {
            this.pagination.current = currentPage;
        }

        this.isCompetitorLinkedProductsTableLoading = true;

        this.httpFetchCompetitorLinkedProducts(
            {
                page: this.pagination.current - 1,
                size: this.pagination.pageSize,
                sortBy: this.sortingData.field,
                sortDirection: this.sortingData.order,
            },
            {
                tradingId: this.currentTradingId,
                competitorCodeList: [this.competitorSelected.competitorCode],
                internalCodeList: this.linkedProductsTableFilterValues.internalCodes || [],
                skuNameList: this.linkedProductsTableFilterValues.skuNames || [],
                storeFormatIdList: [this.competitorSelected.format.id],
                storeRegionIdList: [this.competitorSelected.region.id],
                storeClusterIdList: this.competitorSelected.cluster && this.competitorSelected.cluster.id ? [this.competitorSelected.cluster.id] : [],
                categoryIdList: this.linkedProductsTableFilterValues.categoryIds || [],
                groupIdList: this.linkedProductsTableFilterValues.groupIds || [],
                lastParsingDateTimeFrom: null,
                lastParsingDateTimeTo: null,
                fetch: [],
            }
        ).then((response) => {
            this.competitorProductsTableData = response.data.content;

            this.pagination.total = response.data.totalElements;

            if (needFetchSelectionData) {
                this.fetchSelectionData(response.data.content.map(el => el.id));
            }
        }).finally(() => {
            if (!needFetchSelectionData) {
                this.isCompetitorLinkedProductsTableLoading = false;
            }
        });
    }

    handleFilterGroups(elemIds: any) {
        this.modalLevelFiltersSelected.groups = elemIds.length === 0 || elemIds[elemIds.length - 1] === -1 ? [-1] : elemIds;
        this.modalLevelFiltersSelected.categories = [-1];
        this.modalLevelFiltersSelected.subcategories = [-1];

        this.requestCommonFilter("categories");
        this.fetchFullSkuList();
    }

    handleFilterCategories(elemIds: any) {
        this.modalLevelFiltersSelected.categories = elemIds.length === 0 || elemIds[elemIds.length - 1] === -1 ? [-1] : elemIds;
        this.modalLevelFiltersSelected.subcategories = [-1];

        this.requestCommonFilter("subcategories");
        this.fetchFullSkuList();
    }

    handleFilterSubcategories(elemIds: any) {
        this.modalLevelFiltersSelected.subcategories = elemIds.length === 0 || elemIds[elemIds.length - 1] === -1 ? [-1] : elemIds;

        this.fetchFullSkuList();
    }

    requestCommonFilter(type: keyof IInfoTypesSingle) {
        const infoTypesSingle: IInfoTypesSingle = {
            groups: 'group',
            categories: 'category',
            subcategories: 'subcategory',
        }

        const payload: GetTaskInfo = {
            tradingId: this.currentTradingId,
            groups: this.modalLevelFiltersSelected.groups.filter((item) => item !== -1),
            categories: this.modalLevelFiltersSelected.categories.filter((item) => item !== -1),
            subcategories: this.modalLevelFiltersSelected.subcategories.filter((item) => item !== -1),
            storeFormat: [this.competitorSelected.format.id],
            storeRegion: [this.competitorSelected.region.id],
            storeCluster: this.competitorSelected.cluster && this.competitorSelected.cluster.id ? [this.competitorSelected.cluster.id] : [],
            type: infoTypesSingle[type] as TaskInfoFilterType,
        };

        this.httpGetProductInfo(payload)
            .then((data: { data: ProductInfo }) => {
                const filterData: ProductInfo = data.data;

                if (filterData[type].length) {
                    this.modalLevelFilterOptions[type] = filterData[type].map((i: ProductTag) => {
                        return {value: i.id, label: i.name}
                    });

                    this.modalLevelFilterOptions[type].unshift(this.defaultFilterValue);
                } else {
                    this.modalLevelFiltersSelected[type] = [-1];
                    this.modalLevelFilterOptions[type] = [this.defaultFilterValue];
                }
            });
    }

    updateFilterArray(filterArray: (string | number)[]) {
        if (filterArray.length === 0) {
            filterArray.push(-1);
        } else if (filterArray.includes(-1) && filterArray.length > 1) {
            filterArray.splice(filterArray.indexOf(-1), 1);
        }
    }

    @Watch("modalLevelFiltersSelected", {deep: true})
    onCommonFiltersSelectedChange() {
        Object.keys(this.modalLevelFiltersSelected).forEach((key) => {
            const filterArray = this.modalLevelFiltersSelected[key as keyof IModalLevelFiltersSelected];
            this.updateFilterArray(filterArray);
        });
    }

    @Watch("exportTemplateFiltersSelected", {deep: true})
    onExportTemplateFiltersSelectedChange() {
        Object.keys(this.exportTemplateFiltersSelected).forEach((key) => {
            const filterArray = this.exportTemplateFiltersSelected[key as keyof IExportTemplateFiltersSelected];
            this.updateFilterArray(filterArray);
        });
    }

    handleStartLinkEditing(id: number, parsingUrl: string | null) {
        this.$set(this.editingUrls, id, parsingUrl);
    }

    handleCancelLinkEditing(id: number) {
        this.editingUrls[id] = null;
    }

    handleSaveLink(id: number) {
        this.httpUpdateCompetitorProductLink(id, this.editingUrls[id]).then((data) => {
            const record = this.competitorProductsTableData.find(el => el.id === id);

            if (record) {
                record.parsingUrl = this.editingUrls[id];
            }

            this.showInfo(this.$t('priceMonitoring.parsingProducts.linkUpdatedSuccess') as string);
        })
            .catch((e) => {

            }).finally(() => {
                this.editingUrls[id] = null;
            })
    }

    resetIncludedAndExcludedCheckboxes() {
        this.includedIds = [];
        this.excludedIds = [];
    }

    isRowCheckboxChecked(id: number) {
        if (this.isCommonCheckboxSelected) {
            return !this.excludedIds.includes(id);
        } else {
            return this.includedIds.findIndex(includedId => includedId === id) > -1;
        }
    }

    handleRowCheckboxClicked(item: any, value: boolean) {
        if (this.isCommonCheckboxSelected) {
            if (value) {
                const index = this.excludedIds.findIndex(id => id === item.id);

                if (index > -1) this.excludedIds.splice(index, 1);
            } else {
                this.excludedIds.push(item.id);
            }
        } else {
            if (value) {
                this.includedIds.push(item.id);
            } else {
                const index = this.includedIds.findIndex(id => id === item.id);

                if (index > -1) this.includedIds.splice(index, 1);
            }
        }
    }

    get isNoSelectedProducts(): boolean {
      if (this.pagination.total) {
          if (this.isCommonCheckboxSelected) {
              return this.excludedIds.length === this.pagination.total;
          } else {
              return !this.includedIds.length;
          }
      } else {
          return true;
      }
    }

    handleUnlinkProductsBtnClick() {
        Modal.confirm({
            title: this.$t('priceMonitoring.parsingProducts.confirmUnlinkTitle') as string,
            content: this.$t('priceMonitoring.parsingProducts.confirmUnlinkContent') as string,
            centered: true,
            okText: this.$t('priceMonitoring.parsingProducts.confirmUnlinkOk') as string,
            cancelText: this.$t('shared.buttons.cancel') as string,
            onOk: () => {
                this.httpUnlinkCompetitorProducts({
                    filter: {
                        tradingId: this.currentTradingId,
                        competitorCodeList: [this.competitorSelected.competitorCode],
                        internalCodeList: this.linkedProductsTableFilterValues.internalCodes || [],
                        skuNameList: this.linkedProductsTableFilterValues.skuNames || [],
                        storeFormatIdList: [this.competitorSelected.format.id],
                        storeRegionIdList: [this.competitorSelected.region.id],
                        storeClusterIdList: this.competitorSelected.cluster && this.competitorSelected.cluster.id ? [this.competitorSelected.cluster.id] : [],
                        categoryIdList: this.linkedProductsTableFilterValues.categoryIds || [],
                        groupIdList: this.linkedProductsTableFilterValues.groupIds || [],
                        lastParsingDateTimeFrom: null,
                        lastParsingDateTimeTo: null,
                        fetch: [],
                    },
                    selectCheckboxesData: {
                        isCommonCheckboxSelected: this.isCommonCheckboxSelected,
                        includedIds: this.includedIds,
                        excludedIds: this.excludedIds,
                    },
                }).then(() => {
                    this.showInfo(this.$t('priceMonitoring.parsingProducts.successUnlinkProducts') as string);

                    this.fetchCompetitorLinkedProducts(1);

                    this.resetIncludedAndExcludedCheckboxes();
                    this.isCommonCheckboxSelected = false;

                    this.fetchCompetitorLinkedProductsTableOptions();
                }).catch(() => {
                    this.showError(this.$t('priceMonitoring.parsingProducts.errorUnlinkProducts') as string);
                });
            },
        });
    }

    handleApplyProductsBtnClick() {
      if (this.selectedCompetitorValue && !this.isCompetitorsSelectionRunning) {
          this.isLinkProductsModalVisible = true;
      }
    }

    handleExportTemplateBtnClick() {
      if (!this.isCompetitorsSelectionRunning) {
        this.isExportTemplateModalVisible = true;
        this.loadExportTemplateFilterOptions();
      }
    }

    handleExportTemplateModalHide() {
      this.isExportTemplateModalVisible = false;
      this.resetExportTemplateFilters();
    }

    resetExportTemplateFilters() {
      this.exportTemplateFiltersSelected = {
          groups: [-1],
          categories: [-1],
          subcategories: [-1],
          formats: [-1],
          regions: [-1],
          clusters: [-1],
      };
      this.exportTemplateFilterOptions = {
          groups: [{ value: -1, label: this.$t('shared.selectBox.all') as string }],
          categories: [{ value: -1, label: this.$t('shared.selectBox.all') as string }],
          subcategories: [{ value: -1, label: this.$t('shared.selectBox.all') as string }],
          formats: [{ value: -1, label: this.$t('shared.selectBox.all') as string }],
          regions: [{ value: -1, label: this.$t('shared.selectBox.all') as string }],
          clusters: [{ value: -1, label: this.$t('shared.selectBox.all') as string }],
      };
      this.exportTemplateOnlyKvi = true;
    }

    loadExportTemplateFilterOptions() {
      if (this.exportTemplateFilterOptions.groups.length < 2) {
        this.getExportGroupInfo();
        this.getExportCategoryInfo();
        this.getExportFormatInfo();
        this.getExportRegionInfo();
        this.getExportClusterInfo();
      }
    }

    getExportTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
      return {
        type: taskType,
        tradingId: this.currentTradingId,
        groups: LocalData.filterNumberArrays(this.exportTemplateFiltersSelected.groups),
        categories: LocalData.filterNumberArrays(this.exportTemplateFiltersSelected.categories),
        subcategories: LocalData.filterNumberArrays(this.exportTemplateFiltersSelected.subcategories),
        storeFormat: LocalData.filterNumberArrays(this.exportTemplateFiltersSelected.formats),
        storeRegion: LocalData.filterNumberArrays(this.exportTemplateFiltersSelected.regions),
        storeCluster: LocalData.filterNumberArrays(this.exportTemplateFiltersSelected.clusters),
        segments: null,
        byReports: false,
      };
    }

    resetExportData(type: TaskInfoFilterType) {
      switch (type) {
        case TaskInfoFilterType.group:
          this.exportTemplateFiltersSelected.categories = [-1];
          this.exportTemplateFiltersSelected.subcategories = [-1];
          this.exportTemplateFilterOptions.categories = [this.defaultFilterValue];
          this.exportTemplateFilterOptions.subcategories = [this.defaultFilterValue];
          this.exportTemplateFiltersSelected.formats = [-1];
          this.exportTemplateFiltersSelected.regions = [-1];
          this.exportTemplateFiltersSelected.clusters = [-1];
          this.exportTemplateFilterOptions.formats = [this.defaultFilterValue];
          this.exportTemplateFilterOptions.regions = [this.defaultFilterValue];
          this.exportTemplateFilterOptions.clusters = [this.defaultFilterValue];
          this.getExportCategoryInfo();
          this.getExportSubcategoryInfo();
          this.getExportFormatInfo();
          this.getExportRegionInfo();
          this.getExportClusterInfo();
          break;
        case TaskInfoFilterType.category:
          this.exportTemplateFiltersSelected.subcategories = [-1];
          this.exportTemplateFilterOptions.subcategories = [this.defaultFilterValue];
          this.exportTemplateFiltersSelected.formats = [-1];
          this.exportTemplateFiltersSelected.regions = [-1];
          this.exportTemplateFiltersSelected.clusters = [-1];
          this.exportTemplateFilterOptions.formats = [this.defaultFilterValue];
          this.exportTemplateFilterOptions.regions = [this.defaultFilterValue];
          this.exportTemplateFilterOptions.clusters = [this.defaultFilterValue];
          this.getExportSubcategoryInfo();
          this.getExportFormatInfo();
          this.getExportRegionInfo();
          this.getExportClusterInfo();
          break;
        case TaskInfoFilterType.subcategory:
          this.exportTemplateFiltersSelected.formats = [-1];
          this.exportTemplateFiltersSelected.regions = [-1];
          this.exportTemplateFiltersSelected.clusters = [-1];
          this.exportTemplateFilterOptions.formats = [this.defaultFilterValue];
          this.exportTemplateFilterOptions.regions = [this.defaultFilterValue];
          this.exportTemplateFilterOptions.clusters = [this.defaultFilterValue];
          this.getExportFormatInfo();
          this.getExportRegionInfo();
          this.getExportClusterInfo();
          break;
        case TaskInfoFilterType.format:
          this.exportTemplateFiltersSelected.regions = [-1];
          this.exportTemplateFiltersSelected.clusters = [-1];
          this.exportTemplateFilterOptions.regions = [this.defaultFilterValue];
          this.exportTemplateFilterOptions.clusters = [this.defaultFilterValue];
          this.getExportRegionInfo();
          this.getExportClusterInfo();
          break;
        case TaskInfoFilterType.region:
          this.exportTemplateFiltersSelected.clusters = [-1];
          this.exportTemplateFilterOptions.clusters = [this.defaultFilterValue];
          this.getExportClusterInfo();
          break;
      }
    }

    getExportCategoryInfo() {
      this.httpGetProductInfo(this.getExportTaskInfo(TaskInfoFilterType.category))
        .then((data: { data: ProductInfo }) => {
          const filterData: ProductInfo = data.data;
          if (filterData.categories.length > 0) {
            this.exportTemplateFilterOptions.categories = filterData.categories.map((i: ProductTag) => ({
              value: i.id,
              label: i.name,
            }));
            this.exportTemplateFilterOptions.categories.unshift(this.defaultFilterValue);
          } else {
            this.exportTemplateFiltersSelected.categories = [-1];
            this.exportTemplateFilterOptions.categories = [this.defaultFilterValue];
            this.resetExportData(TaskInfoFilterType.category);
          }
        });
    }

    getExportGroupInfo() {
      this.httpGetProductInfo(this.getExportTaskInfo(TaskInfoFilterType.group))
        .then((data: { data: ProductInfo }) => {
          const filterData: ProductInfo = data.data;
          if (filterData.groups.length > 0) {
            this.exportTemplateFilterOptions.groups = filterData.groups.map((i: ProductTag) => ({
              value: i.id,
              label: i.name,
            }));
            this.exportTemplateFilterOptions.groups.unshift(this.defaultFilterValue);
          } else {
            this.exportTemplateFilterOptions.groups = [this.defaultFilterValue];
          }
        });
    }

    getExportSubcategoryInfo() {
      this.httpGetProductInfo(this.getExportTaskInfo(TaskInfoFilterType.subcategory))
        .then((data: { data: ProductInfo }) => {
          const filterData: ProductInfo = data.data;
          if (filterData.subcategories.length > 0) {
            this.exportTemplateFilterOptions.subcategories = filterData.subcategories.map((i: ProductTag) => ({
              value: i.id,
              label: i.name,
            }));
            this.exportTemplateFilterOptions.subcategories.unshift(this.defaultFilterValue);
          } else {
            this.exportTemplateFilterOptions.subcategories = [this.defaultFilterValue];
          }
        });
    }

    getExportFormatInfo() {
      this.httpGetProductInfo(this.getExportTaskInfo(TaskInfoFilterType.format))
        .then((data: { data: ProductInfo }) => {
          const filterData: ProductInfo = data.data;
          if (filterData.storeFormat && filterData.storeFormat.length > 0) {
            this.exportTemplateFilterOptions.formats = filterData.storeFormat.map((i) => ({
              value: i.id,
              label: i.name,
            }));
            this.exportTemplateFilterOptions.formats.unshift(this.defaultFilterValue);
          } else {
            this.exportTemplateFilterOptions.formats = [this.defaultFilterValue];
          }
        });
    }

    getExportRegionInfo() {
      this.httpGetProductInfo(this.getExportTaskInfo(TaskInfoFilterType.region))
        .then((data: { data: ProductInfo }) => {
          const filterData: ProductInfo = data.data;
          if (filterData.storeRegion && filterData.storeRegion.length > 0) {
            this.exportTemplateFilterOptions.regions = filterData.storeRegion.map((i) => ({
              value: i.id,
              label: i.name,
            }));
            this.exportTemplateFilterOptions.regions.unshift(this.defaultFilterValue);
          } else {
            this.exportTemplateFilterOptions.regions = [this.defaultFilterValue];
          }
        });
    }

    getExportClusterInfo() {
      this.httpGetProductInfo(this.getExportTaskInfo(TaskInfoFilterType.cluster))
        .then((data: { data: ProductInfo }) => {
          const filterData: ProductInfo = data.data;
          if (filterData.storeCluster && filterData.storeCluster.length > 0) {
            this.exportTemplateFilterOptions.clusters = filterData.storeCluster.map((i: ProductTag) => ({
              value: i.id,
              label: i.name,
            }));
            this.exportTemplateFilterOptions.clusters.unshift(this.defaultFilterValue);
          } else {
            this.exportTemplateFilterOptions.clusters = [this.defaultFilterValue];
          }
        });
    }

    handleExportFilterGroups(elemIds: any) {
      const newGroups = elemIds.length === 0 || elemIds[elemIds.length - 1] === -1 ? [-1] : elemIds;
      if (!!newGroups.length && !LocalData.compareTwoArrays(newGroups, this.exportTemplateFiltersSelected.groups)) {
        this.exportTemplateFiltersSelected.groups = newGroups;
        this.resetExportData(TaskInfoFilterType.group);
      }
    }

    handleExportFilterCategories(elemIds: any) {
      const newCategories = elemIds.length === 0 || elemIds[elemIds.length - 1] === -1 ? [-1] : elemIds;
      if (!!newCategories.length && !LocalData.compareTwoArrays(newCategories, this.exportTemplateFiltersSelected.categories)) {
        this.exportTemplateFiltersSelected.categories = newCategories;
        this.resetExportData(TaskInfoFilterType.category);
      }
    }

    handleExportFilterSubcategories(elemIds: any) {
      this.exportTemplateFiltersSelected.subcategories = elemIds.length === 0 || elemIds[elemIds.length - 1] === -1 ? [-1] : elemIds;
      this.resetExportData(TaskInfoFilterType.subcategory);
    }

    handleExportFilterFormats(elemIds: any) {
      const newFormats = elemIds.length === 0 || elemIds[elemIds.length - 1] === -1 ? [-1] : elemIds;
      if (!!newFormats.length && !LocalData.compareTwoArrays(newFormats, this.exportTemplateFiltersSelected.formats)) {
        this.exportTemplateFiltersSelected.formats = newFormats;
        this.resetExportData(TaskInfoFilterType.format);
      }
    }

    handleExportFilterRegions(elemIds: any) {
      const newRegions = elemIds.length === 0 || elemIds[elemIds.length - 1] === -1 ? [-1] : elemIds;
      if (!!newRegions.length && !LocalData.compareTwoArrays(newRegions, this.exportTemplateFiltersSelected.regions)) {
        this.exportTemplateFiltersSelected.regions = newRegions;
        this.resetExportData(TaskInfoFilterType.region);
      }
    }

    handleExportFilterClusters(elemIds: any) {
      const newClusters = elemIds.length === 0 || elemIds[elemIds.length - 1] === -1 ? [-1] : elemIds;
      this.exportTemplateFiltersSelected.clusters = newClusters;
    }

    handleDownloadTemplate() {
      this.isExportTemplateLoading = true;

      const payload = {
        tradingNetId: this.currentTradingId,
        groupIds: LocalData.filterNumberArrays(this.exportTemplateFiltersSelected.groups),
        categoryIds: LocalData.filterNumberArrays(this.exportTemplateFiltersSelected.categories),
        subcategoryIds: LocalData.filterNumberArrays(this.exportTemplateFiltersSelected.subcategories),
        formatIds: LocalData.filterNumberArrays(this.exportTemplateFiltersSelected.formats),
        regionIds: LocalData.filterNumberArrays(this.exportTemplateFiltersSelected.regions),
        clusterIds: LocalData.filterNumberArrays(this.exportTemplateFiltersSelected.clusters),
        onlyKvi: this.exportTemplateOnlyKvi,
      };

      this.$http.post('/api/parsing/product-links/export', payload, {
        method: 'POST',
        responseType: 'blob',
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const dateString = new Date().toISOString().slice(0, 19).replace(/[:-]/g, '').replace('T', '_');
          link.setAttribute('download', `${this.$t('priceMonitoring.parsingProducts.exportLinkFileName') as string}_${dateString}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.isExportTemplateModalVisible = false;
        })
        .catch((e) => {
          this.showError(this.$t('priceMonitoring.parsingProducts.errorDownloadTemplate') as string);
        })
        .finally(() => {
          this.isExportTemplateLoading = false;
        });
    }

    handleStartCompetitorsSelectionBtnClick() {
        if (!this.selectedCompetitorValue) return;

        const competitorValue = this.selectedCompetitorValue;

        Modal.confirm({
            title: this.$t('priceMonitoring.parsingProducts.confirmSelectionTitle') as string,
            content: this.$t('priceMonitoring.parsingProducts.confirmSelectionContent') as string,
            centered: true,
            okText: this.$t('priceMonitoring.parsingProducts.confirmSelectionOk') as string,
            cancelText: this.$t('shared.buttons.cancel') as string,
            onOk: () => {
                this.httpStartAutomaticCompetitorsSelection({
                    site: this.selectedSite,
                    selectCheckboxesData: {
                        isCommonCheckboxSelected: this.isCommonCheckboxSelected,
                        includedIds: this.includedIds,
                        excludedIds: this.excludedIds,
                    },
                    filter: {
                        tradingId: this.currentTradingId,
                        competitorCodeList: [this.competitorSelected.competitorCode],
                        internalCodeList: this.linkedProductsTableFilterValues.internalCodes || [],
                        skuNameList: this.linkedProductsTableFilterValues.skuNames || [],
                        storeFormatIdList: [this.competitorSelected.format.id],
                        storeRegionIdList: [this.competitorSelected.region.id],
                        storeClusterIdList: this.competitorSelected.cluster && this.competitorSelected.cluster.id ? [this.competitorSelected.cluster.id] : [],
                        categoryIdList: this.linkedProductsTableFilterValues.categoryIds || [],
                        groupIdList: this.linkedProductsTableFilterValues.groupIds || [],
                        lastParsingDateTimeFrom: null,
                        lastParsingDateTimeTo: null,
                        fetch: [],
                    },
                }).then(() => {
                    this.showInfo(this.$t('priceMonitoring.parsingProducts.selectionStartedSuccess') as string);

                    this.setCompetitorState(competitorValue);

                    const state = this.competitorSelectionStates[competitorValue];

                    Vue.set(state, 'isRunning', true);
                    Vue.set(state, 'tasksMap', new Map());
                    Vue.set(state, 'progress', 0);

                    this.startSelectionPolling(competitorValue);
                }).catch(() => {
                    this.showError(this.$t('priceMonitoring.parsingProducts.errorStartSelection') as string);
                });
            },
        });
    }

    getCheckboxGroupOptions(filterOptionsKey: keyof ILinkedProductsTableOptions) {
        return (this.linkedProductsTableOptions[filterOptionsKey] as (string | number)[]).map((el: string | number | IdAndName) => ({
            label: typeof el === 'object' ? el.name : String(el),
            value: typeof el === 'object' ? el.id : el,
        }));
    }

    parseCompetitorData(stringValue: string): ILocalstorageCompetitorData {
        const resObj: ILocalstorageCompetitorData = {
            code: '',
            formatId: '',
            regionId: '',
        };

        const params = stringValue.split(';').filter(param => param.trim() !== '');

        for (const param of params) {
            const [key, value] = param.split('=');

            if (key) {
                resObj[key.trim() as keyof ILocalstorageCompetitorData] = value ? value.trim() : '';
            }
        }

        return resObj;
    }

  badgeStyle(errorsAmount: number | null) {
      return {
          backgroundColor: 'white',
          size: '10px',
          color: !!errorsAmount ? 'red' : 'gray',
          borderColor: !!errorsAmount ? 'red' : 'gray',
      }
  }

  get disableCompetitorProductLinksUploadButtons(): boolean {
      return !this.competitorProductLinksFile || this.isSelectionDataLoading || this.isCompetitorsSelectionRunning;
  }

  get disableCompetitorProductLinksFileInput(): boolean {
      return this.isSelectionDataLoading || this.isCompetitorsSelectionRunning;
  }

  uploadCompetitorProductLinksFile() {
      if (!this.competitorProductLinksFile) {
          this.showError(this.$t('shared.messages.selectFile') as string);
          return;
      }

      if (!this.theMarket) {
          this.showError(this.$t('shared.messages.selectTradingNetwork') as string);
          return;
      }

      const uploadFile = new FormData();

      uploadFile.append(
          'file',
          new Blob([this.competitorProductLinksFile]),
          this.competitorProductLinksFile.name
      );

      this.isSelectionDataLoading = true;

      this.httpUploadCompetitorProductLinksFile(this.theMarket.id, uploadFile)
          .then((r) => {
              this.showInfo(r.data ? r.data : this.$t('shared.messages.fileUploadedSuccess') as string);

              this.competitorProductLinksFile = null;
          })
          .catch((e) => {
              this.showError(this.$t('shared.messages.errorUploadFile') as string);

              this.competitorProductLinksFile = null;
          })
          .finally(() => {
              this.isSelectionDataLoading = false;

              this.fetchCompetitorLinkedProducts();
              this.fetchCompetitorLinkedProductsTableOptions();
              this.getCompetitorProductLinksErrorsAmount();
          });
  }

  getCompetitorProductLinksErrorsAmount() {
      if (!this.theMarket) {
          return;
      }

      this.httpGetCompetitorProductLinksErrorsAmount(this.theMarket.id)
          .then((r) => {
              this.competitorProductLinksErrorsAmount = r.data;
          });
  }

  downloadCompetitorProductLinksErrors() {
      if (!this.theMarket) {
          this.showError(this.$t('shared.messages.selectTradingNetwork') as string);
          return;
      }

      this.isSelectionDataLoading = true;

      this.httpGetCompetitorProductLinksErrors(this.theMarket.id)
          .then((response) => {
              if (!response.data.size) {
                  this.showInfo(this.$t('shared.messages.noErrors') as string)
                  return;
              }

              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', this.$t('priceMonitoring.parsingProducts.errorsDownloadLinkFileName') as string);

              document.body.appendChild(link);
              link.click();
          })
          .finally(() => {
              this.isSelectionDataLoading = false;
          });
  }
}
